/* booksy-ai.js — generált fájl (widget/build.py), ne szerkeszd kézzel. szovegverzio=jogi_v3 forras-sha256=7abd74369c283a56 */
/*
 * Booksy AI widget (WP5) — vanilla JS, Shadow DOM (mode: "open"), CSAK textContent / DOM-építés.
 *
 * Szabályok (KIVITELEZESI_PROMPT 2/6., 4. WP4–WP5, 5. pont; TERV 7.1/9, 7.1/13):
 *  - HTML-t szövegből soha nem állítunk elő; minden szöveg textContent / szövegcsomópont.
 *  - Link csak https, hoszt: booksy.ro / www.booksy.ro / cdn.shopify.com (kép), rel="noopener".
 *  - Kosárba: a /cart/add.js CSAK `id` és `quantity` mezőt kap; kosárattribútumot nem írunk.
 *  - Puszta oldalnézetnél 0 hálózati kérés és 0 tárolóírás. Az első érintés (belépő / indító) után:
 *    GET config → ALTCHA-kihívás → munkamenet; tárolókulcs pontosan kettő: booksy_ai_session, booksy_ai_conv;
 *    24 óra után törlődnek; minden tárolóhozzáférés try/catch.
 *  - Telefonszám a widgetben soha (2. pont 6.): a chat fix szövegeiben csak a Kapcsolat-oldal és az info-cím.
 *  - A hozzájárulási jelölőnégyzet mindig üresen indul; a gomb mindig aktív, pipa nélkül notify.err_consent.
 *  - A szövegmező válasz közben sem tiltott; csak a küldés gomb aria-disabled.
 *
 * A build.py a három jelölt helyre beágyazza a CSS-t, a ui_text HU/RO táblát és a badge_ro táblát.
 */
(() => {
  'use strict';

  const CSS = "/* Booksy AI widget — stílus (KIVITELEZESI_PROMPT 5. pont). A Shadow DOM-ba kerül (build.py ágyazza be).\n   Színek CSAK a :host tokenjeiből; máshol hex szín nem állhat (statikus teszt: tests/widget).\n   Betűk: a téma által betöltött Cormorant 400 és Lora 400 / 400 dőlt / 600 (F0 0.5). Webfontot a widget nem tölt.\n   Súly-helyettesítés (WP0.5): Cormorant 600 → 400 (--bai-w-cim), Lora 700 → 600 (--bai-w-700); font-synthesis: none. */\n\n:host {\n  all: initial;\n  display: block;\n  font-synthesis: none;\n  -webkit-text-size-adjust: 100%;\n\n  --bai-ink: #2c2c2c;\n  --bai-ink-soft: #5b5b57;\n  --bai-cream: #fcfaf4;\n  --bai-paper: #ffffff;\n  --bai-line: #e6e0d4;\n  --bai-line-soft: #efe9dd;\n  --bai-input-line: #8a8478;\n  --bai-placeholder: #6b6b66;\n  --bai-teal: #18444b;\n  --bai-teal-deep: #0f1f22;\n  --bai-on-teal: #f5f5f0;\n  --bai-neon: #00ff7f;\n  --bai-sub-on-teal: #cfe3df;\n  --bai-toggle-line: #4f7479;\n  --bai-green: #15803d;\n  --bai-green-hover: #116a33;\n  --bai-green-text: #166534;\n  --bai-link-hover: #14532d;\n  --bai-green-bg: #e3f1e7;\n  --bai-instock-dot: #16a34a;\n  --bai-chip-line: #b9d7c3;\n  --bai-amber-text: #92400e;\n  --bai-amber-bg: #fdf1dc;\n  --bai-out-text: #44443f;\n  --bai-out-bg: #efeee9;\n  --bai-out-line: #d9d6cc;\n  --bai-warn-text: #9a3412;\n  --bai-warn-bg: #fff4ec;\n  --bai-warn-line: #f3c9ab;\n  --bai-echo-bg: #e9efee;\n  --bai-echo-line: #cddad8;\n  --bai-send-off: #9fb8a8;\n  --bai-skeleton: #efeae0;\n  --bai-skeleton-line: #ece6da;\n\n  --bai-f: Lora, Georgia, serif;\n  --bai-f-cim: Cormorant, Georgia, serif;\n  --bai-w-600: 600;\n  --bai-w-700: 600;\n  --bai-w-cim: 400;\n}\n\n:host([data-hely=\"kereses\"]) { margin-top: 16px; }\n:host([data-hely=\"fo\"]) { display: contents; }\n\n*, *::before, *::after { box-sizing: border-box; }\n[hidden] { display: none !important; }\n\nbutton, input, textarea {\n  font-family: var(--bai-f);\n  margin: 0;\n}\nbutton { cursor: pointer; -webkit-tap-highlight-color: transparent; }\na { -webkit-tap-highlight-color: transparent; }\n\n.bai-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n  clip-path: inset(50%);\n  white-space: nowrap;\n}\n\n/* ---- Fókusz (csak :focus-visible) ---- */\n:focus { outline: none; }\n:focus-visible { outline: 2px solid var(--bai-green); outline-offset: 2px; }\n.bai-fejlec :focus-visible { outline: 2px solid var(--bai-neon); outline-offset: 2px; }\n\n/* ---- Belépő-sor (termékoldal, „Kérdezz hasonlót”, keresés) ---- */\n.bai-belepo {\n  width: 100%;\n  min-height: 52px;\n  padding: 10px 14px;\n  border: 1px solid var(--bai-chip-line);\n  border-radius: 12px;\n  background: var(--bai-paper);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-align: left;\n  font-family: var(--bai-f);\n  color: var(--bai-ink);\n}\n.bai-belepo-ikon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--bai-teal);\n  color: var(--bai-neon);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.bai-belepo-szoveg { display: flex; flex-direction: column; gap: 2px; flex: 1 1 auto; min-width: 0; }\n.bai-belepo-cim { font-size: 14px; font-weight: var(--bai-w-600); line-height: 1.35; }\n.bai-belepo-al { font-size: 12px; line-height: 1.35; color: var(--bai-ink-soft); }\n.bai-belepo-nyil { color: var(--bai-green-text); flex-shrink: 0; }\n\n/* ---- Lebegő indító ---- */\n.bai-indito {\n  position: fixed;\n  right: 16px;\n  bottom: 16px;\n  z-index: 9980;\n  height: 52px;\n  padding: 0 20px 0 14px;\n  border: 0;\n  border-radius: 50px;\n  background: var(--bai-teal);\n  color: var(--bai-on-teal);\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-family: var(--bai-f);\n  font-weight: var(--bai-w-600);\n  font-size: 15px;\n  box-shadow: 0 6px 18px rgba(15, 31, 34, .28);\n}\n.bai-indito svg { color: var(--bai-neon); }\n.bai-indito.bai-emelt { bottom: 88px; }\n/* 10-25 (2. külső audit, UX-04): mobilon kerek, 48 px-es ikon — a felirat vizuálisan rejtett, a képernyőolvasó\n   továbbra is a teljes aria-labelt kapja; alul a biztonsági sáv (iPhone) is számít. */\n@media (max-width: 767.98px) {\n  .bai-indito {\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    gap: 0;\n    justify-content: center;\n    right: 12px;\n    bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n  }\n  .bai-indito > span {\n    position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap;\n  }\n  .bai-indito.bai-emelt { bottom: calc(80px + env(safe-area-inset-bottom, 0px)); }\n  .bai-indito.bai-kitér { opacity: 0; pointer-events: none; transition: opacity 120ms; }\n}\n/* Kettős gyűrű (teal + krém); a neon gyűrű itt tilos (krémen 1,29:1). */\n.bai-indito:focus-visible {\n  outline: 2px solid var(--bai-teal);\n  outline-offset: 2px;\n  box-shadow: 0 0 0 2px var(--bai-cream);\n}\n\n/* ---- Panel ---- */\n.bai-panel {\n  position: fixed;\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n  background: var(--bai-cream);\n  color: var(--bai-ink);\n  font-family: var(--bai-f);\n  font-size: 15px;\n  line-height: 1.5;\n  overflow: hidden;\n  animation: bai-nyit 180ms ease-out;\n}\n.bai-panel[data-mobil] {\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100dvh;\n}\n.bai-panel:not([data-mobil]) {\n  right: 24px;\n  bottom: 24px;\n  width: 400px;\n  height: min(640px, calc(100dvh - 48px));\n  border-radius: 16px;\n  box-shadow: 0 16px 48px rgba(15, 31, 34, .24);\n}\n@keyframes bai-nyit {\n  from { opacity: 0; translate: 0 8px; }\n  to { opacity: 1; translate: 0 0; }\n}\n\n/* ---- Fejléc (K1) ---- */\n.bai-fejlec {\n  min-height: 64px;\n  padding: 0 8px 0 16px;\n  background: var(--bai-teal);\n  color: var(--bai-on-teal);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n.bai-fejlec-ikon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--bai-teal-deep);\n  color: var(--bai-neon);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.bai-fejlec-szoveg { display: flex; flex-direction: column; flex: 1 1 auto; min-width: 0; padding: 6px 0; }\n.bai-cim { font-family: var(--bai-f-cim); font-weight: var(--bai-w-cim); font-size: 24px; line-height: 1.1; }\n.bai-alcim { font-size: 12px; line-height: 1.3; color: var(--bai-sub-on-teal); overflow-wrap: anywhere; }\n.bai-nyelvpar {\n  display: flex;\n  border: 1px solid var(--bai-toggle-line);\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n.bai-nyelvgomb, .bai-nyelv-egy {\n  height: 44px;\n  min-width: 44px;\n  padding: 0 10px;\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  color: var(--bai-on-teal);\n  font-weight: var(--bai-w-600);\n  font-size: 13px;\n}\n.bai-nyelvgomb[aria-pressed=\"true\"] {\n  background: var(--bai-on-teal);\n  color: var(--bai-teal);\n  font-weight: var(--bai-w-700);\n}\n.bai-nyelv-egy { display: none; border: 1px solid var(--bai-toggle-line); flex-shrink: 0; }\n.bai-bezar {\n  width: 44px;\n  height: 44px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--bai-on-teal);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n@media (max-width: 359.98px) {\n  .bai-fejlec { gap: 8px; }\n  .bai-fejlec-ikon, .bai-nyelvpar { display: none; }\n  .bai-nyelv-egy { display: inline-flex; align-items: center; justify-content: center; }\n}\n\n/* ---- Üzenetlista ---- */\n.bai-log {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.bai-log > :first-child { margin-top: auto; }\n.bai-vevo {\n  align-self: flex-end;\n  max-width: 82%;\n  padding: 10px 14px;\n  background: var(--bai-teal);\n  color: var(--bai-on-teal);\n  border-radius: 16px 16px 4px 16px;\n  font-size: 15px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n.bai-visszhang {\n  align-self: flex-end;\n  max-width: 82%;\n  padding: 10px 14px;\n  background: var(--bai-echo-bg);\n  color: var(--bai-ink);\n  border: 1px solid var(--bai-echo-line);\n  border-radius: 16px 16px 4px 16px;\n  font-size: 13px;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n.bai-bot {\n  position: relative;\n  align-self: flex-start;\n  max-width: 92%;\n  padding: 10px 14px;\n  background: var(--bai-paper);\n  border: 1px solid var(--bai-line);\n  border-radius: 16px 16px 16px 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow-wrap: anywhere;\n}\n.bai-bot:focus-visible { outline-offset: 2px; }\n.bai-bot p { margin: 0; font-size: 15px; line-height: 1.5; white-space: pre-line; }\n.bai-bot p.bai-apro { font-size: 13px; line-height: 1.5; color: var(--bai-ink-soft); }\n/* 10-25 (UX-01): rétegzett adatkezelési tájékoztató */\n/* 10-26 (tulaj: „A — Rövid”): a chat szövegtörzse talpatlan, jobban pásztázható (UX-07); a cím serif marad */\n.bai-log, .bai-bevitel, .bai-chip, .bai-bot, .bai-szovegmezo, .bai-bevitel .bai-linksor, .bai-adatkezeles { font-family: system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif; }\n.bai-bevitel .bai-jeloles { margin: 8px 0 0; }\n.bai-adatkezeles {\n  background: none; border: 0; padding: 0; cursor: pointer; font: inherit; font-size: 13px;\n  color: var(--bai-ink-soft); text-decoration: underline; text-underline-offset: 2px;\n}\n.bai-adatkezeles:focus-visible { outline: 2px solid var(--bai-teal); outline-offset: 2px; border-radius: 4px; }\n.bai-adatreszlet summary {\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--bai-ink);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  padding: 4px 0;\n}\n.bai-adatreszlet summary:focus-visible { outline: 2px solid var(--bai-teal); outline-offset: 2px; border-radius: 4px; }\n.bai-adatreszlet[open] summary { margin-bottom: 4px; }\n.bai-bot p.bai-kozepes { font-size: 13px; line-height: 1.5; color: var(--bai-ink-soft); }\n.bai-bot .bai-elvalaszto { padding-top: 8px; border-top: 1px solid var(--bai-line-soft); }\n.bai-bot.bai-siker { border-color: var(--bai-chip-line); padding: 12px 14px; gap: 8px; }\n.bai-siker-sor { display: flex; gap: 10px; align-items: flex-start; }\n.bai-siker-ikon {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--bai-green-bg);\n  color: var(--bai-green-text);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.bai-bot-gombok { display: flex; flex-wrap: wrap; gap: 8px; }\n\n/* ---- Állapotjelző (M12) ---- */\n.bai-gepel {\n  align-self: flex-start;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  background: var(--bai-paper);\n  border: 1px solid var(--bai-line);\n  border-radius: 16px 16px 16px 4px;\n  font-size: 14px;\n  font-style: italic;\n  color: var(--bai-ink-soft);\n}\n.bai-pottyok { display: inline-flex; gap: 4px; }\n.bai-pottyok > span {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--bai-teal);\n  animation: bai-pulzus 1.2s ease-in-out infinite;\n}\n.bai-pottyok > span:nth-child(2) { animation-delay: .2s; }\n.bai-pottyok > span:nth-child(3) { animation-delay: .4s; }\n@keyframes bai-pulzus {\n  0%, 100% { opacity: 1; }\n  50% { opacity: .3; }\n}\n.bai-csontvaz {\n  padding: 12px;\n  background: var(--bai-paper);\n  border: 1px solid var(--bai-skeleton-line);\n  border-radius: 12px;\n  display: flex;\n  gap: 12px;\n}\n.bai-csontvaz-borito { width: 64px; height: 96px; border-radius: 4px; background: var(--bai-skeleton); flex-shrink: 0; }\n.bai-csontvaz-sorok { flex: 1 1 auto; display: flex; flex-direction: column; gap: 8px; padding-top: 4px; }\n.bai-csontvaz-sorok > span { display: block; background: var(--bai-skeleton); }\n.bai-csontvaz-sorok > span:nth-child(1) { width: 40%; height: 10px; border-radius: 5px; }\n.bai-csontvaz-sorok > span:nth-child(2) { width: 85%; height: 14px; border-radius: 7px; }\n.bai-csontvaz-sorok > span:nth-child(3) { width: 30%; height: 14px; border-radius: 7px; }\n.bai-csontvaz-sorok > span:nth-child(4) { width: 60%; height: 18px; border-radius: 4px; }\n\n/* ---- Gombok, linkek, chipek ---- */\n.bai-chipek { display: flex; flex-wrap: wrap; gap: 8px; }\n.bai-chip {\n  min-height: 44px;\n  padding: 0 16px;\n  border: 1px solid var(--bai-chip-line);\n  border-radius: 999px;\n  background: var(--bai-paper);\n  color: var(--bai-green-text);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.3;\n}\n.bai-gomb {\n  min-height: 44px;\n  padding: 0 16px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: var(--bai-w-600);\n  line-height: 1.2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  text-align: center;\n  text-decoration: none;\n}\n.bai-gomb-teli { border: 0; background: var(--bai-green); color: var(--bai-paper); }\n.bai-gomb-teli:hover { background: var(--bai-green-hover); }\n.bai-gomb-keretes { border: 1px solid var(--bai-green); background: var(--bai-paper); color: var(--bai-green-text); }\n.bai-link { color: var(--bai-green-text); text-decoration: underline; text-underline-offset: 3px; }\n.bai-link:hover { color: var(--bai-link-hover); }\n.bai-linksor {\n  align-self: flex-start;\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font-size: 14px;\n  color: var(--bai-green-text);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n.bai-linksor:hover { color: var(--bai-link-hover); }\n\n/* ---- Termékkártya (K2) ---- */\n.bai-kartyak { display: flex; flex-direction: column; gap: 12px; }\n.bai-kartya {\n  width: 100%;\n  padding: 12px;\n  background: var(--bai-paper);\n  border: 1px solid var(--bai-line);\n  border-radius: 12px;\n  color: var(--bai-ink);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.bai-kartya-fo { display: flex; gap: 12px; align-items: flex-start; }\n.bai-borito {\n  width: 64px;\n  height: 96px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  object-fit: cover;\n  background: var(--bai-teal);\n}\ndiv.bai-borito {\n  display: flex;\n  align-items: flex-end;\n  padding: 6px;\n  font-family: var(--bai-f-cim);\n  font-size: 13px;\n  line-height: 1.05;\n  color: var(--bai-cream);\n  overflow: hidden;\n  overflow-wrap: anywhere;\n}\n.bai-kartya-adat { display: flex; flex-direction: column; gap: 4px; min-width: 0; flex: 1 1 auto; }\n.bai-szerzo { font-size: 11px; line-height: 1.4; letter-spacing: .08em; text-transform: uppercase; color: var(--bai-ink-soft); }\n.bai-kartya-cim { margin: 0; font-size: 15px; font-weight: var(--bai-w-600); line-height: 1.35; }\n.bai-nyelvsor { font-size: 12px; line-height: 1.45; color: var(--bai-ink-soft); }\n.bai-arblokk { display: flex; flex-direction: column; gap: 4px; }\n.bai-ar { font-size: 16px; font-weight: var(--bai-w-700); line-height: 1.4; color: var(--bai-green); }\n.bai-jelveny {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 8px;\n  border: 1px solid;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: var(--bai-w-700);\n  line-height: 1.4;\n}\n.bai-j-instock { background: var(--bai-green-bg); color: var(--bai-green-text); border-color: rgba(21, 128, 61, .25); }\n.bai-j-supplier { background: var(--bai-amber-bg); color: var(--bai-amber-text); border-color: rgba(146, 64, 14, .25); }\n.bai-j-out, .bai-j-neutral { background: var(--bai-out-bg); color: var(--bai-out-text); border-color: var(--bai-out-line); }\n.bai-potty-zold { width: 8px; height: 8px; border-radius: 50%; background: var(--bai-instock-dot); flex-shrink: 0; }\n.bai-romagy { font-size: 12px; line-height: 1.45; color: var(--bai-ink-soft); }\n.bai-tartalek {\n  align-self: flex-start;\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: var(--bai-w-600);\n  color: var(--bai-green-text);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n.bai-miert { margin: 0; font-size: 13px; line-height: 1.5; }\n.bai-miert strong { font-weight: var(--bai-w-600); }\n.bai-kartya-gombok { display: flex; gap: 8px; }\n.bai-kartya-gombok > * { flex: 1 1 0; min-width: 0; height: 44px; padding: 0 10px; }\n.bai-kosarban {\n  border: 1px solid var(--bai-green);\n  background: var(--bai-paper);\n  color: var(--bai-green-text);\n}\n.bai-kosar-linkek { display: flex; flex-direction: column; }\n.bai-kosar-linkek a {\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 14px;\n}\n.bai-kartya-hiba { margin: 0; font-size: 13px; line-height: 1.45; color: var(--bai-warn-text); }\n\n/* ---- Beviteli sáv (K3) ---- */\n.bai-bevitel {\n  flex-shrink: 0;\n  margin: 0;\n  padding: 10px 12px 8px;\n  background: var(--bai-paper);\n  border-top: 1px solid var(--bai-line);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.bai-jeloles { margin: 0; font-size: 12px; line-height: 1.45; color: var(--bai-ink-soft); }\n.bai-bevitel-sor { display: flex; gap: 8px; align-items: flex-end; }\n.bai-szovegmezo {\n  display: block;\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 48px;\n  max-height: 120px;\n  padding: 12px 16px;\n  border: 1px solid var(--bai-input-line);\n  border-radius: 24px;\n  background: var(--bai-paper);\n  font-size: 16px;\n  line-height: 1.4;\n  color: var(--bai-ink);\n  resize: none;\n}\n.bai-szovegmezo[aria-invalid=\"true\"] { border: 2px solid var(--bai-warn-text); padding: 11px 15px; }\n/* 10-26: a „(személyes adat nélkül)” helyőrző keskeny kijelzőn is egy sorban (ne vágódjon le) */\n.bai-szovegmezo::placeholder { font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n@media (max-width: 400px) { .bai-szovegmezo::placeholder { font-size: 13px; } }\n::placeholder { color: var(--bai-placeholder); opacity: 1; }\n.bai-kuld {\n  width: 48px;\n  height: 48px;\n  flex-shrink: 0;\n  border: 0;\n  border-radius: 50%;\n  background: var(--bai-green);\n  color: var(--bai-paper);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.bai-kuld:hover { background: var(--bai-green-hover); }\n.bai-kuld[aria-disabled=\"true\"] { background: var(--bai-send-off); cursor: default; }\n.bai-bevitel-also { display: flex; justify-content: space-between; align-items: center; gap: 8px; }\n.bai-bevitel-also .bai-linksor { align-self: auto; }\n.bai-adatkezeles {\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  font-size: 13px;\n  color: var(--bai-ink-soft);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n/* ---- Űrlapok (M05, M07, M10) és hibaállapot ---- */\n.bai-urlap {\n  margin: 0;\n  padding: 14px;\n  background: var(--bai-paper);\n  border: 1px solid var(--bai-line);\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.bai-termeksor { font-size: 13px; line-height: 1.5; color: var(--bai-ink-soft); }\n.bai-termeksor strong { color: var(--bai-ink); font-weight: var(--bai-w-600); }\n.bai-idezet { font-size: 13px; line-height: 1.5; color: var(--bai-ink-soft); }\n.bai-idezet span { color: var(--bai-ink); }\n.bai-mezo { display: flex; flex-direction: column; gap: 6px; }\n.bai-cimke { font-size: 14px; font-weight: var(--bai-w-600); line-height: 1.4; }\n.bai-cimke .bai-nem-kotelezo { font-weight: 400; color: var(--bai-ink-soft); }\n.bai-input {\n  width: 100%;\n  height: 48px;\n  padding: 0 14px;\n  border: 1px solid var(--bai-input-line);\n  border-radius: 10px;\n  background: var(--bai-paper);\n  font-size: 16px;\n  color: var(--bai-ink);\n}\ntextarea.bai-input { height: auto; min-height: 64px; padding: 10px 14px; line-height: 1.4; resize: none; }\ntextarea.bai-input.bai-magas { min-height: 96px; }\n.bai-input[aria-invalid=\"true\"] { border: 2px solid var(--bai-warn-text); padding: 0 13px; }\ntextarea.bai-input[aria-invalid=\"true\"] { padding: 9px 13px; }\n.bai-hibaszoveg {\n  margin: 0;\n  display: flex;\n  gap: 6px;\n  align-items: flex-start;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--bai-warn-text);\n}\n.bai-hibaszoveg svg { flex-shrink: 0; margin-top: 3px; }\n.bai-behuzott { margin-left: 32px; }\n.bai-seged { margin: 0; font-size: 12px; line-height: 1.45; color: var(--bai-ink-soft); }\n.bai-jelolo { display: flex; gap: 10px; align-items: flex-start; font-size: 13px; line-height: 1.5; cursor: pointer; }\n.bai-jelolo input { width: 22px; height: 22px; margin: 1px 0 0; accent-color: var(--bai-green); flex-shrink: 0; }\n.bai-jelolo input[aria-invalid=\"true\"] { outline: 2px solid var(--bai-warn-text); outline-offset: 2px; }\n.bai-urlap-gomb {\n  width: 100%;\n  height: 48px;\n  border: 0;\n  border-radius: 50px;\n  background: var(--bai-green);\n  color: var(--bai-paper);\n  font-weight: var(--bai-w-600);\n  font-size: 15px;\n}\n.bai-urlap-gomb:hover { background: var(--bai-green-hover); }\n.bai-urlap-gomb[aria-busy=\"true\"] { cursor: default; }\n.bai-szamlalo { align-self: flex-end; font-size: 12px; color: var(--bai-ink-soft); }\n\n/* ---- Nem elérhető (M10) ---- */\n.bai-urlapnezet {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.bai-urlapnezet > :first-child { margin-top: auto; }\n.bai-nemelerheto {\n  padding: 12px 14px;\n  background: var(--bai-warn-bg);\n  border: 1px solid var(--bai-warn-line);\n  border-radius: 12px;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n.bai-nemelerheto svg { color: var(--bai-warn-text); flex-shrink: 0; margin-top: 1px; }\n.bai-nemelerheto-szoveg { display: flex; flex-direction: column; gap: 4px; }\n.bai-nemelerheto-cim { font-size: 15px; font-weight: var(--bai-w-600); color: var(--bai-warn-text); }\n.bai-nemelerheto-torzs { font-size: 14px; line-height: 1.5; }\n.bai-kozepre { align-self: center; }\n\n/* ---- Mozgás kikapcsolva ---- */\n@media (prefers-reduced-motion: reduce) {\n  .bai-panel { animation: none; }\n  .bai-pottyok > span { animation: none; }\n}\n";
  const SZ = {"hu":{"ai.reminder":"Emlékeztetőül: mesterséges intelligencia vagyok, nem ember.","ai.whoami":"Nem vagyok ember: a Booksy AI vagyok, egy mesterséges intelligencia. Ha emberrel szeretnél beszélni, továbbítom a kérdésed a kollégáinknak, ők e-mailben válaszolnak. [Beszélnék egy kollégával]","card.cart":"Kosárba","card.cart_added":"A kosárban van","card.cart_adding":"Kosárba teszem…","card.cart_fail":"Most nem sikerült kosárba tenni. Nézd meg a termékoldalon.","card.cart_link":"Kosárlink (ha Safariba vagy Chrome-ba váltasz)","card.cart_open":"Kosár megnyitása","card.count.many":"{{n}} ajánlat","card.count.one":"1 ajánlat","card.fallback":"Nézd meg a termékoldalon","card.lang":"Nyelv: {{nyelv}}","card.notify":"Értesíts, ha megjön","card.page":"Termékoldal","card.why":"Miért ezt?","chat.conv_reset":"Ez a beszélgetés hosszúra nyúlt, ezért újat kezdtem. Kérdezz nyugodtan újra, szívesen segítek!","chat.err":"Most nem sikerült válaszolnom. Próbáld újra, vagy továbbíthatom a kérdésed egy kollégának.","chat.offline":"Nincs internetkapcsolat. Ha visszajön, próbáld újra.","chat.retry":"Újrapróbálom","chat.too_long":"Legfeljebb 1000 karaktert írhatsz.","chips.after":"Mutass hasonlót · Csak raktáron lévőt · Beszélnék egy kollégával","chips.after_label":"Javasolt lépések","chips.ask_no":"Nem, köszönöm","chips.ask_yes":"Igen, kérdezzétek meg","chips.q.mas_korosztaly":"Más korosztálynak","chips.q.olcsobb":"Olcsóbbat kérek","chips.q.tobb_ilyen":"Mutass hasonlót","chips.start":"Könyvajánló · Ajándék · Társasjáték · Konkrét könyv","chips.start_label":"Gyors kezdés","composer.handoff":"Beszélnék egy kollégával","composer.label":"Üzeneted a Booksy AI-nak","composer.notice":"AI-asszisztens, tévedhet. Adatkezelő: Booksy (APRS S.R.L.); a beszélgetést külső AI-szolgáltató dolgozza fel.","composer.placeholder":"Írd le, mit keresel (személyes adat nélkül)…","composer.privacy":"Adatkezelés","composer.privacy_more":"Adatkezelés és jogaid","composer.send":"Küldés","contact.button":"Kapcsolat","form.err_email":"Adj meg egy érvényes e-mail-címet.","form.err_question":"Írd le röviden a kérdésed.","form.sending":"Küldés…","handoff.after":"Addig is szívesen segítek könyvet vagy társasjátékot választani.","handoff.after_two_fails":"Úgy látom, ebben nem tudtam segíteni. Továbbítsam a kérdésed egy kollégának? [Igen, továbbítsd] [Nem, köszönöm]","handoff.button":"Elküldöm","handoff.done":"Továbbítottuk az üzeneted a kollégáinknak (azonosító: AIJ-{{id}}). A válasz e-mailben érkezik, az info@booksy.ro címről.","handoff.echo":"Továbbítást kértem · válaszcím: {{email_maszk}}","handoff.email":"E-mail-címed a válaszhoz","handoff.fail":"Most nem sikerült továbbítani. Kérlek, írj nekünk az info@booksy.ro címre.","handoff.form":"Kérdés továbbítása egy kollégának","handoff.forward":"Továbbítsd a kérdésem","handoff.info_link":"Szállítási tájékoztató","handoff.note":"Megjegyzés (nem kötelező)","handoff.note_ph":"Például: melyik könyvről vagy szállításról van szó","handoff.order":"Rendelésszám (nem kötelező)","handoff.order_err":"Írd be a rendelésszámot úgy, ahogy a visszaigazoló levélben áll, vagy hagyd üresen.","handoff.order_note":"Ha a rendelésedről kérdezel, a rendelés adatait csak akkor írjuk meg, ha az itt megadott e-mail-cím egyezik a rendelésben szereplővel.","handoff.privacy":"A kérdésedet, a megjegyzésedet és az e-mail-címedet a bolt munkatársai látják, és csak a válaszhoz használjuk. A továbbított kérdést a lezárása után 180 napig őrizzük meg. [Adatkezelés]","handoff.quote":"Ezt továbbítjuk a kollégáinknak:","header.close":"Bezárás","header.dialog_name":"Booksy AI – mesterséges intelligencia, nem ember","header.lang":"A beszélgetés nyelve","header.lang_hu":"HU – magyar","header.lang_ro":"RO – română","header.sub":"AI-asszisztens · nem ember","header.title":"Booksy AI","launcher.aria":"Booksy AI megnyitása – mesterséges intelligencia válaszol, nem ember","launcher.label":"Booksy AI","minor.notice":"Emlékeztetőül: mesterséges intelligencia vagyok, egy számítógépes program, nem ember. Ha valamiben bizonytalan vagy, kérd egy szülő vagy egy felnőtt segítségét. Magadról ne írj ide személyes adatot.","notify.after":"Először egy megerősítő levelet küldünk: értesítést csak a megerősítés után kapsz. A kérést bármikor visszavonhatod, itt a chatben vagy a megerősítő levél linkjével. Ha a termék 12 hónapon belül nem lesz újra rendelhető, a kérést töröljük.","notify.button":"Kérem az értesítést","notify.consent":"Hozzájárulok, hogy a Booksy (APRS S.R.L.) erről az egy termékről egyetlen e-mailt küldjön erre a címre, amikor újra rendelhető. A címemet csak erre használhatja; ez nem hírlevél. [Adatkezelési tájékoztató]","notify.consent_help":"Ha még nem vagy 16 éves, ezt a kérést a szülőd adja le.","notify.echo":"Értesítést kértem: {{cim}} · {{email_maszk}}","notify.email":"E-mail-címed","notify.email_ph":"pelda@email.ro","notify.err_consent":"Az értesítéshez jelöld be a hozzájárulást.","notify.fail":"Most nem sikerült rögzíteni a kérést. Kérlek, írj nekünk az info@booksy.ro címre.","notify.form":"Értesítés kérése: {{cim}}","notify.intro":"A termékoldal szerint jelenleg nem kapható, és azt nem tudom megmondani, mikor lesz újra. Kérhetsz egyetlen e-mailes értesítést:","notify.product":"Termék:","notify.revoke":"Értesítés visszavonása","notify.revoke_fail":"Most nem sikerült visszavonni a kérést. Kérlek, írj nekünk az info@booksy.ro címre.","notify.revoked":"Ha ebben a beszélgetésben új értesítéskérést rögzítettünk, azt visszavontuk. Ha korábban már kértél értesítést erre a termékre, azt a megerősítő levél „A kérés visszavonása” linkjével vonhatod vissza.","notify.sent":"Köszönjük. Ha a kérést rögzítettük, megerősítő levelet küldünk erre a címre. Értesítést csak azután küldünk, hogy a levélben a „Megerősítem” gombra kattintasz, és a megnyíló oldalon megerősíted a kérést. Időpontot nem tudunk ígérni.","notify.spam":"Nem jött meg? Nézd meg a Promóciók és a Levélszemét mappát is. Ha ott sincs, lehet, hogy a levél késik, erre a termékre már van élő kérésed, vagy egy korlát miatt nem rögzítettük a kérést.","pdp.echo":"Erről a termékről kérdezek: {{cim}}","pdp.similar":"Kérdezz hasonlót a Booksy AI-tól","pdp.sub":"Kérdezd a Booksy AI-t · mesterséges intelligencia","pdp.title.book":"Kérdésed van erről a könyvről?","pdp.title.game":"Kérdésed van erről a társasjátékról?","pdp.title.other":"Kérdésed van erről a termékről?","refusal":"Erre nem tudok válaszolni. Könyvben vagy társasjátékban szívesen segítek, vagy továbbíthatom a kérdésed egy kollégának.","search.link":"Kérdezz a Booksy AI-tól","search.sub":"mesterséges intelligencia","search.zero":"Nem találod? Kérdezd a Booksy AI-t","sr.bot_prefix":"Booksy AI, mesterséges intelligencia:","status.searching":"Keresem a katalógusban…","tpl.complaint":"Köszönöm, hogy jelezted. A panaszokról nem én döntök, hanem a kollégáink. Közvetlenül is írhatsz nekik az info@booksy.ro címre. Emlékeztetőül: mesterséges intelligencia vagyok, nem ember.","tpl.coupon":"Kuponkódot és kedvezményt nem adok. Az aktuális árat a chatben megjelenő termékkártyán és a termékoldalon látod.","tpl.date":"Pontos szállítási dátumot nem tudok ígérni. A termékoldal szerint: {{szallitas}}.","tpl.date_nocard":"Pontos szállítási dátumot nem tudok ígérni; a szállítási időt minden termékoldal mutatja.","tpl.deadline_handoff":"Ha fix határidőd van, továbbíthatom a kérdésed a kollégáinknak.","tpl.delivery_general":"A raktáron jelzésű termékek általában 1–3, a beszállítótól rendelhetők 4–7 munkanap alatt érkeznek; az adott termék idejét a termékoldala mutatja. Pontos dátumot nem tudok ígérni.","tpl.haggle":"Az árakról nem alkudozom, és egyedi árat sem adok. Az aktuális árat a termékoldalon látod.","tpl.keret":"a megadott, legfeljebb {{n}} lejes kereten belül","tpl.keret_osszesen":"A javasolt {{db}} termék együtt {{osszeg}} lei, ez belefér a megadott {{n}} lejes keretbe.","tpl.logged":"Ezt az üzenetedet időponttal együtt rögzítettem, és a kollégáink is megkapták (azonosító: AIJ-{{id}}). Ha megadod az e-mail-címed, oda válaszolnak.","tpl.not_found":"Ezt a címet nem találom a kínálatunkban. Ha szeretnéd, továbbítom a kérdésed egy kollégának, aki utánanéz a beszerzés lehetőségének. Ezt ígérni nem tudom, csak megkérdezni.","tpl.order_howto":"Így rendelhetsz: tedd a terméket a kosárba, majd a pénztárban add meg a szállítási címet, és válassz: csomagautomata (16 lei, 150 lei kosárértéktől ingyenes), házhoz futár (22 lei, 200 lei kosárértéktől ingyenes) vagy bolti átvétel Székelyudvarhelyen (ingyenes). Fizetni a pénztárban lehet, a végleges díjat is ott látod. [Szállítási tájékoztató]","tpl.other_company":"Más cégek elérhetőségéről nem tájékoztatok. Könyvben vagy társasjátékban szívesen segítek.","tpl.other_edition":"Ha másik kiadásra gondoltál, írd meg a szerzőt vagy az ISBN-t.","tpl.out_of_scope.adatkezeles":"Személyes adat módosítását vagy törlését nem tudom elintézni.","tpl.out_of_scope.egyeb":"Ebben nem tudok segíteni.","tpl.out_of_scope.elallas":"Visszaküldésről és elállásról nem én döntök.","tpl.out_of_scope.fizetes":"Fizetési ügyeket nem intézek.","tpl.out_of_scope.offer":"Továbbíthatom a kérdésed a kollégáinknak; ők e-mailben válaszolnak, az info@booksy.ro címről. [Továbbítsd a kérdésem] [Szállítási tájékoztató]","tpl.out_of_scope.panasz":"Ezt a kollégáink intézik.","tpl.out_of_scope.rendeles_allapot":"A rendelések állapotát nem látom.","tpl.out_of_scope.szallitas":"A szállítás és az átvétel részleteit nem én intézem.","tpl.price":"Az aktuális ár a termékkártyán látható; a termékoldal az irányadó.","tpl.privacy_request":"Személyes adat törlését, módosítását vagy kiadását nem tudom elintézni. Írj nekünk az info@booksy.ro címre, vagy kérd, hogy továbbítsam a kérésed. A jogaidról az adatkezelési tájékoztató szól.","tpl.refund":"Visszatérítést nem tudok elindítani, és nem is ígérhetek. A visszaküldés és a visszatérítés szabályait a visszaküldési szabályzat írja le; a saját ügyedben a kollégáink segítenek.","tpl.return_info":"A visszaküldési szabályzat szerint 14 napon belül indoklás nélkül elállhatsz a vásárlástól; könyvnél a védőfólia felbontása után is, de a szokásos megtekintést meghaladó használatból eredő értékcsökkenésért a vásárló felel. A visszaküldés költsége a vásárlót terheli, sérült terméknél nem. [Elállás a szerződéstől] [Visszaküldési szabályzat]","tpl.same_author":"Ugyanettől a szerzőtől ezek most raktáron vannak:","tpl.shipping_calc":"{{n}} lei kosárértéknél a csomagautomatás szállítás {{automata}}, a házhoz futár {{futar}}; bolti átvétellel ingyenes. Kedvezménykóddal a kosárérték a határ alá kerülhet; a végleges díjat a pénztár mutatja. [Szállítási tájékoztató]","tpl.shipping_info":"A webshop pénztára szerint: házhoz futár 22 lei, 200 lei kosárértéktől ingyenes; csomagautomata 16 lei, 150 lei kosárértéktől ingyenes; bolti átvétel Székelyudvarhelyen (Sportului 4) ingyenes. Kedvezménykóddal a kosárérték a határ alá kerülhet; a végleges díjat a pénztár mutatja. [Szállítási tájékoztató]","tpl.store_info":"A Booksy könyvesbolt címe: Str. Sportului 4, Riverside Retail Park, 535600 Székelyudvarhely (Odorheiu Secuiesc). Nyitvatartás: hétfőtől szombatig 9–21, vasárnap 9–18. A webshopban 0–24-ben rendelhetsz; elérhetőségeinket és a térképet a Kapcsolat oldalon találod. [Kapcsolat]","tpl.which":"Erre gondolsz?","tpl.withdrawal":"Az elállásodat nem tudom feldolgozni, és nem is döntök róla. Hogy biztosan célba érjen, és visszaigazolást kapj, jelentsd be az elállási oldalon, vagy írj az info@booksy.ro címre. Az elállás módját és határidejét az elállási oldal írja le.","tpl.withdrawal_fallback":"Az elállásodat nem tudom feldolgozni, és nem is döntök róla. Hogy biztosan célba érjen, írj az info@booksy.ro címre, vagy kérd, hogy továbbítsam a kollégáinknak. A szabályokat a visszaküldési szabályzat írja le.","unavailable.body":"Írd meg a kérdésed, és egy kollégánk e-mailben válaszol, az info@booksy.ro címről.","unavailable.counter":"{{n}} / 300","unavailable.form":"Kérdés küldése a kollégáinknak","unavailable.privacy":"A kérdésedet és az e-mail-címedet a bolt munkatársai látják, és csak a válaszhoz használjuk. A továbbított kérdést a lezárása után 180 napig őrizzük meg. [Adatkezelés]","unavailable.question":"Kérdésed","unavailable.question_ph":"Például: milyen könyvet ajánlotok egy 10 évesnek?","unavailable.search":"Addig keress a webshopban","unavailable.title":"A Booksy AI most nem érhető el.","welcome.1":"Szia! A Booksy AI vagyok: mesterséges intelligencia, nem a bolt munkatársa. Könyvet és társasjátékot ajánlok a kínálatunkból, és megmutatom, mit ír a termékoldal a készletről és a szállítási időről.","welcome.2":"Tévedhetek, ezért az árat és a szállítási időt mindig a termékoldalon nézd meg. Rendeléssel, fizetéssel és visszaküldéssel kapcsolatban a kollégáink segítenek: a „Beszélnék egy kollégával” gombbal elküldheted nekik a kérdésed. Írhatsz magyarul vagy románul.","welcome.more":"Tudnivalók és adatkezelés","welcome.objection":"Tiltakozhatsz az ellen, hogy jogos érdekünk alapján kezeljük az adataidat: írj az info@booksy.ro címre.","welcome.privacy":"Adatkezelő: APRS S.R.L. (Booksy). Kérlek, ne írj ide nevet, címet, telefonszámot, személyi számot vagy egészségügyi adatot. Az üzenetedet az Anthropic mesterséges intelligenciája dolgozza fel, az USA-ban is. A beszélgetést 30 napig őrizzük meg, a felismert azonosítókat (pl. telefonszám, e-mail-cím) kitakarva. A chat válaszait és a mutatott termékadatokat bizonyításként 24 hónapig őrizzük, a 30. nap után a beszélgetéstől leválasztva. Részletek és a jogaid: [Adatkezelés]","welcome.short":"Szia! Segítek könyvet vagy társasjátékot találni. Mit keresel?","welcome.terms_link":"[A chat feltételei]"},"ro":{"ai.reminder":"Ca să știi: sunt o inteligență artificială, nu un om.","ai.whoami":"Nu sunt un om: sunt Booksy AI, o inteligență artificială. Dacă vrei să vorbești cu un om, le transmit întrebarea ta colegilor noștri, care îți răspund pe e-mail. [Vreau să vorbesc cu un coleg]","card.cart":"Adaugă în coș","card.cart_added":"E în coș","card.cart_adding":"Se adaugă în coș…","card.cart_fail":"Acum nu am reușit să-l adaug în coș. Vezi pagina produsului.","card.cart_link":"Link spre coș (dacă treci în Safari sau Chrome)","card.cart_open":"Deschide coșul","card.count.many":"{{n}} recomandări","card.count.one":"1 recomandare","card.fallback":"Vezi pe pagina produsului","card.lang":"Limba: {{nyelv}}","card.notify":"Anunță-mă","card.page":"Pagina produsului","card.why":"De ce:","chat.conv_reset":"Conversația asta a devenit lungă, așa că am început una nouă. Întreabă-mă din nou, te ajut cu plăcere!","chat.err":"Acum nu am reușit să răspund. Încearcă din nou sau pot transmite întrebarea ta unui coleg.","chat.offline":"Nu există conexiune la internet. Încearcă din nou când revine.","chat.retry":"Încerc din nou","chat.too_long":"Poți scrie cel mult 1000 de caractere.","chips.after":"Arată-mi ceva asemănător · Doar ce e în stoc · Vreau să vorbesc cu un coleg","chips.after_label":"Pași sugerați","chips.ask_no":"Nu, mulțumesc","chips.ask_yes":"Da, întrebați","chips.q.mas_korosztaly":"Pentru altă vârstă","chips.q.olcsobb":"Ceva mai ieftin","chips.q.tobb_ilyen":"Arată-mi ceva asemănător","chips.start":"Recomandare de carte · Cadou · Joc de societate · O carte anume","chips.start_label":"Pentru început","composer.handoff":"Vreau să vorbesc cu un coleg","composer.label":"Mesajul tău către Booksy AI","composer.notice":"Asistent AI, poate greși. Operator: Booksy (APRS S.R.L.); conversația este prelucrată de un furnizor extern de AI.","composer.placeholder":"Scrie ce cauți (fără date personale)…","composer.privacy":"Prelucrarea datelor","composer.privacy_more":"Prelucrarea datelor și drepturile tale","composer.send":"Trimite","contact.button":"Contact","form.err_email":"Introdu o adresă de e-mail validă.","form.err_question":"Scrie pe scurt întrebarea ta.","form.sending":"Se trimite…","handoff.after":"Până atunci, te ajut cu plăcere să alegi o carte sau un joc de societate.","handoff.after_two_fails":"Se pare că nu te-am putut ajuta cu asta. Vrei să transmit întrebarea ta unui coleg? [Da, transmite-o] [Nu, mulțumesc]","handoff.button":"Trimit","handoff.done":"Am transmis mesajul tău colegilor noștri (număr: AIJ-{{id}}). Răspunsul vine pe e-mail, de la adresa info@booksy.ro.","handoff.echo":"Am cerut transmiterea · adresa pentru răspuns: {{email_maszk}}","handoff.email":"Adresa ta de e-mail pentru răspuns","handoff.fail":"Nu am reușit să transmitem întrebarea. Te rugăm să ne scrii la info@booksy.ro.","handoff.form":"Transmiterea întrebării către un coleg","handoff.forward":"Transmite întrebarea mea","handoff.info_link":"Informații despre livrare","handoff.note":"Observație (opțional)","handoff.note_ph":"De exemplu: despre ce carte sau livrare este vorba","handoff.order":"Numărul comenzii (opțional)","handoff.order_err":"Scrie numărul comenzii așa cum apare în e-mailul de confirmare sau lasă câmpul gol.","handoff.order_note":"Dacă întrebi despre comanda ta, îți scriem detaliile comenzii doar dacă adresa de e-mail de aici este aceeași cu cea din comandă.","handoff.privacy":"Întrebarea, observația și adresa ta de e-mail le văd colegii din magazin și le folosim doar pentru răspuns. Păstrăm întrebarea transmisă 180 de zile după închiderea ei. [Prelucrarea datelor]","handoff.quote":"Transmitem colegilor noștri:","header.close":"Închide","header.dialog_name":"Booksy AI – inteligență artificială, nu un om","header.lang":"Limba conversației","header.lang_hu":"HU – magyar","header.lang_ro":"RO – română","header.sub":"asistent AI · nu un om","header.title":"Booksy AI","launcher.aria":"Deschide Booksy AI – îți răspunde inteligența artificială, nu un om","launcher.label":"Booksy AI","minor.notice":"Ca să știi: sunt o inteligență artificială, un program de calculator, nu un om. Dacă nu ești sigur de ceva, cere ajutorul unui părinte sau al unui adult. Nu scrie aici date personale despre tine.","notify.after":"Mai întâi îți trimitem un e-mail de confirmare: notificarea o primești doar după confirmare. Poți retrage cererea oricând, aici în chat sau cu linkul din e-mailul de confirmare. Dacă produsul nu va putea fi comandat din nou în următoarele 12 luni, ștergem cererea.","notify.button":"Vreau notificarea","notify.consent":"Sunt de acord ca Booksy (APRS S.R.L.) să îmi trimită un singur e-mail la această adresă despre acest produs, când va putea fi comandat din nou. Adresa mea se folosește doar pentru asta; nu este un newsletter. [Politica de confidențialitate]","notify.consent_help":"Dacă nu ai împlinit 16 ani, cererea trebuie făcută de părintele tău.","notify.echo":"Am cerut o notificare: {{cim}} · {{email_maszk}}","notify.email":"Adresa ta de e-mail","notify.email_ph":"exemplu@email.ro","notify.err_consent":"Pentru notificare, bifează acordul.","notify.fail":"Nu am reușit să înregistrăm cererea. Te rugăm să ne scrii la info@booksy.ro.","notify.form":"Cerere de notificare: {{cim}}","notify.intro":"Conform paginii produsului, momentan nu este disponibil și nu pot spune când va fi disponibil din nou. Poți cere o singură notificare pe e-mail:","notify.product":"Produs:","notify.revoke":"Retrage notificarea","notify.revoke_fail":"Acum nu am reușit să anulăm cererea. Te rugăm să ne scrii la info@booksy.ro.","notify.revoked":"Dacă în această conversație am înregistrat o cerere nouă de notificare, am anulat-o. Dacă ai cerut deja o notificare pentru acest produs, o poți retrage cu linkul „Retrage cererea” din e-mailul de confirmare.","notify.sent":"Mulțumim. Dacă am înregistrat cererea, îți trimitem un e-mail de confirmare la această adresă. Îți trimitem notificarea doar după ce apeși în el butonul „Confirm” și confirmi cererea pe pagina care se deschide. Nu putem promite o dată.","notify.spam":"Nu a sosit? Verifică și dosarele Promoții și Spam. Dacă nu e nici acolo, poate e-mailul întârzie, ai deja o cerere activă pentru acest produs sau, din cauza unei limite, nu am putut înregistra cererea.","pdp.echo":"Am o întrebare despre: {{cim}}","pdp.similar":"Întreabă Booksy AI de ceva asemănător","pdp.sub":"Întreabă Booksy AI · inteligență artificială","pdp.title.book":"Ai o întrebare despre această carte?","pdp.title.game":"Ai o întrebare despre acest joc de societate?","pdp.title.other":"Ai o întrebare despre acest produs?","refusal":"La asta nu pot răspunde. Te ajut cu plăcere cu o carte sau un joc de societate, sau pot transmite întrebarea ta unui coleg.","search.link":"Întreabă Booksy AI","search.sub":"inteligență artificială","search.zero":"Nu găsești? Întreabă Booksy AI","sr.bot_prefix":"Booksy AI, inteligență artificială:","status.searching":"Caut în catalog…","tpl.complaint":"Mulțumesc că ne-ai spus. Despre reclamații nu decid eu, ci colegii noștri. Le poți scrie și direct la info@booksy.ro. Ca să știi: sunt o inteligență artificială, nu un om.","tpl.coupon":"Nu ofer coduri de reducere sau reduceri. Prețul actual îl vezi pe fișa produsului din chat și pe pagina produsului.","tpl.date":"Nu pot promite o dată exactă de livrare. Pe pagina produsului scrie: {{szallitas}}.","tpl.date_nocard":"Nu pot promite o dată exactă de livrare; termenul de livrare apare pe fiecare pagină de produs.","tpl.deadline_handoff":"Dacă ai un termen fix, pot transmite întrebarea ta colegilor noștri.","tpl.delivery_general":"Produsele marcate „în stoc” ajung de obicei în 1–3 zile lucrătoare, cele de la furnizor în 4–7 zile lucrătoare; termenul exact apare pe pagina produsului. Nu pot promite o dată exactă.","tpl.haggle":"Nu negociez prețurile și nu ofer prețuri personalizate. Prețul actual îl vezi pe pagina produsului.","tpl.keret":"în limita bugetului indicat, de cel mult {{n}} lei","tpl.keret_osszesen":"Cele {{db}} produse propuse costă împreună {{osszeg}} lei, în limita bugetului de {{n}} lei indicat.","tpl.logged":"Am înregistrat acest mesaj cu data și ora, iar colegii noștri l-au primit (număr: AIJ-{{id}}). Dacă îți lași adresa de e-mail, îți răspund acolo.","tpl.not_found":"Nu găsesc acest titlu în oferta noastră. Dacă vrei, transmit întrebarea ta unui coleg, care verifică dacă îl putem aduce. Nu pot promite asta, doar pot întreba.","tpl.order_howto":"Poți comanda așa: adaugă produsul în coș, apoi la finalizarea comenzii introdu adresa de livrare și alege: locker (16 lei, gratuit de la 150 lei valoarea coșului), curier la domiciliu (22 lei, gratuit de la 200 lei) sau ridicare din magazinul din Odorheiu Secuiesc (gratuit). Plata se face la finalizarea comenzii, unde vezi și taxa finală. [Informații despre livrare]","tpl.other_company":"Nu ofer date de contact ale altor companii. Te ajut cu plăcere cu o carte sau un joc de societate.","tpl.other_edition":"Dacă te gândeai la altă ediție, scrie-mi autorul sau codul ISBN.","tpl.out_of_scope.adatkezeles":"Nu pot rezolva modificarea sau ștergerea datelor personale.","tpl.out_of_scope.egyeb":"Nu te pot ajuta cu asta.","tpl.out_of_scope.elallas":"Despre retururi și retragerea din contract nu decid eu.","tpl.out_of_scope.fizetes":"Nu mă ocup de plăți.","tpl.out_of_scope.offer":"Îți pot transmite întrebarea colegilor noștri; ei îți răspund pe e-mail, de la adresa info@booksy.ro. [Transmite întrebarea mea] [Informații despre livrare]","tpl.out_of_scope.panasz":"De asta se ocupă colegii noștri.","tpl.out_of_scope.rendeles_allapot":"Nu văd starea comenzilor.","tpl.out_of_scope.szallitas":"Nu mă ocup eu de detaliile livrării și ale ridicării.","tpl.price":"Prețul actual se vede pe fișa produsului; pagina produsului este cea de referință.","tpl.privacy_request":"Nu pot rezolva ștergerea, modificarea sau furnizarea datelor personale. Scrie-ne la info@booksy.ro sau cere-mi să transmit solicitarea ta. Despre drepturile tale afli din politica de confidențialitate.","tpl.refund":"Nu pot nici iniția, nici promite o rambursare. Regulile pentru retur și rambursare sunt descrise în politica de retur; în cazul tău concret te ajută colegii noștri.","tpl.return_info":"Conform politicii de retur, te poți retrage din cumpărare în 14 zile, fără motivare; la cărți și după desfacerea foliei de protecție, dar cumpărătorul răspunde pentru deprecierea rezultată din folosirea peste ce e necesar pentru a vedea produsul. Costul returului îl suportă cumpărătorul, cu excepția produselor deteriorate. [Retragere din contract] [Politica de retur]","tpl.same_author":"De la același autor, acestea sunt acum în stoc:","tpl.shipping_calc":"La o valoare a coșului de {{n}} lei: livrare la locker {{automata}}, curier la domiciliu {{futar}}; ridicarea din magazin este gratuită. Cu un cod de reducere, valoarea coșului poate scădea sub prag; taxa finală apare la finalizarea comenzii. [Informații despre livrare]","tpl.shipping_info":"Conform casei magazinului online: curier la domiciliu 22 lei, gratuit de la 200 lei valoarea coșului; locker 16 lei, gratuit de la 150 lei valoarea coșului; ridicare din magazinul din Odorheiu Secuiesc (Str. Sportului 4) gratuit. Cu un cod de reducere, valoarea coșului poate scădea sub prag; taxa finală apare la finalizarea comenzii. [Informații despre livrare]","tpl.store_info":"Librăria Booksy se află la adresa: Str. Sportului 4, Riverside Retail Park, 535600 Odorheiu Secuiesc. Program: luni–sâmbătă 9–21, duminică 9–18. Pe site poți comanda non-stop; datele de contact și harta le găsești pe pagina Contact. [Contact]","tpl.which":"La asta te gândești?","tpl.withdrawal":"Nu pot procesa retragerea ta din contract și nici nu decid asupra ei. Ca să ajungă sigur la noi și să primești confirmarea, transmite-o pe pagina de retragere sau scrie-ne la info@booksy.ro. Modul și termenul de retragere sunt descrise pe pagina de retragere.","tpl.withdrawal_fallback":"Nu pot procesa retragerea ta din contract și nici nu decid asupra ei. Ca să ajungă sigur la noi, scrie-ne la info@booksy.ro sau cere-mi să o transmit colegilor noștri. Regulile sunt descrise în politica de retur.","unavailable.body":"Scrie-ne întrebarea ta, iar un coleg îți răspunde pe e-mail, de la adresa info@booksy.ro.","unavailable.counter":"{{n}} / 300","unavailable.form":"Trimite întrebarea colegilor noștri","unavailable.privacy":"Întrebarea și adresa ta de e-mail le văd colegii din magazin și le folosim doar pentru răspuns. Păstrăm întrebarea transmisă 180 de zile după închiderea ei. [Prelucrarea datelor]","unavailable.question":"Întrebarea ta","unavailable.question_ph":"De exemplu: ce carte recomandați pentru un copil de 10 ani?","unavailable.search":"Până atunci, caută în magazinul online","unavailable.title":"Booksy AI nu este disponibil acum.","welcome.1":"Bună! Sunt Booksy AI: o inteligență artificială, nu un angajat al magazinului. Îți recomand cărți și jocuri de societate din oferta noastră și îți arăt ce scrie pe pagina produsului despre stoc și despre termenul de livrare.","welcome.2":"Pot greși, așa că verifică mereu prețul și termenul de livrare pe pagina produsului. La comenzi, plăți și retururi te ajută colegii noștri: cu butonul „Vreau să vorbesc cu un coleg” le poți trimite întrebarea ta. Poți scrie în maghiară sau în română.","welcome.more":"Informații și prelucrarea datelor","welcome.objection":"Te poți opune prelucrării datelor tale pe baza interesului nostru legitim: scrie-ne la info@booksy.ro.","welcome.privacy":"Operator: APRS S.R.L. (Booksy). Te rog să nu scrii aici nume, adresă, număr de telefon, CNP sau date despre sănătate. Mesajul tău este prelucrat de inteligența artificială a companiei Anthropic, inclusiv în SUA. Păstrăm conversația 30 de zile, după ce ascundem datele de identificare recunoscute (de ex. telefon, e-mail). Răspunsurile chatului și datele de produs afișate le păstrăm 24 de luni, ca dovadă, separat de conversație după a 30-a zi. Detalii și drepturile tale: [Prelucrarea datelor]","welcome.short":"Bună! Te ajut să găsești o carte sau un joc de societate. Ce cauți?","welcome.terms_link":"[Condițiile chatului]"}};
  const BADGE_RO = {"Azonnal kézbesítjük":"se livrează imediat","Beszállítótól · 4–5 munkanap":"de la furnizor, 4–5 zile lucrătoare","Beszállítótól · 4–7 munkanap":"de la furnizor, 4–7 zile lucrătoare","Elfogyott":"epuizat","Jelenleg nem kapható · értesítést kérhetsz":"momentan indisponibil, poți cere o notificare","Raktáron":"în stoc","Raktáron · 1–3 munkanap":"în stoc, 1–3 zile lucrătoare"};

  const g = typeof globalThis !== 'undefined' ? globalThis : window;

  // ------------------------------------------------------------------------------------------- állandók
  const KULCS_SESSION = 'booksy_ai_session';
  const KULCS_CONV = 'booksy_ai_conv';
  const ELETTARTAM_MS = 24 * 60 * 60 * 1000;
  const ALAP = 'https://www.booksy.ro';
  const LINK_HOSZTOK = ['booksy.ro', 'www.booksy.ro'];
  const KEP_HOSZTOK = ['cdn.shopify.com', 'www.booksy.ro', 'booksy.ro'];   // a téma képei a saját domainen (10-24)
  // Az API a dispatcher vhostján fut (`/ai/`, TERV 5.4); a relatív `/ai/v1` a Shopifyra mutatna.
  const API_HOSZTOK = ['booksy.ro', 'www.booksy.ro', 'dispatcher.booksy.ro', 'ai.booksy.ro'];   // 10-24: saját cím (a tulaj gépén a dispatcher Tailscale-re oldódik)
  const UTAK = {
    adatkezeles: '/policies/privacy-policy#booksy-ai',
    feltetelek: '/pages/booksy-ai-feltetelek',
    szallitas: '/policies/shipping-policy',
    kapcsolat: '/pages/kapcsolat',
    kereses: '/search',
    elallas: '/pages/elallas',
    visszakuldes: '/policies/refund-policy',
    kosar: '/cart',
  };
  const MOBIL_MQ = '(max-width: 767.98px)';
  const MAX_UZENET = 1000;
  const MAX_KERDES = 300;
  const EMAIL_MINTA = /^[A-Za-z0-9._%+\-]{1,64}@[A-Za-z0-9.\-]{1,190}\.[A-Za-z]{2,24}$/;
  const RENDELESSZAM_MINTA = /^(BKY-\d{8}-\d{4}|#?\d{3,6})$/;
  const KOSARLINK_MINTA = /^\/cart\/\d+:\d+$/;
  const SVGNS = 'http://www.w3.org/2000/svg';
  const IKONOK = {
    konyv: ['M3 6c2.6-1 5.6-1 9 1 3.4-2 6.4-2 9-1v12c-2.6-1-5.6-1-9 1-3.4-2-6.4-2-9-1z', 'M12 7v12'],
    x: ['M6 6l12 12M18 6L6 18'],
    kuld: ['M5 12h14M13 6l6 6-6 6'],
    pipa: ['M5 12l5 5 9-10'],
    nyil: ['M9 6l6 6-6 6'],
    doboz: ['M3 7l9-4 9 4v10l-9 4-9-4z', 'M3 7l9 4 9-4M12 11v10'],
    tiltott: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', 'M6 18L18 6'],
    figyel: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', 'M12 7v6M12 16.5v.5'],
  };

  // ------------------------------------------------------------------------------------------- állapot
  const A = {
    cfg: null,
    api: null,
    ny: 'hu',
    mod: null,            // a szerver módja (az első érintés után): normal | urlap | ki
    erintve: false,       // az első érintés megtörtént-e (csak utána írunk a tárolóba)
    elokeszites: null,    // Promise: config + munkamenet
    token: null,
    conv: null,
    nyitva: false,
    foglalt: false,
    belepesi: 'egyeb',
    utolsoVevo: '',
    megnyito: null,
    tortenet: false,
    gorgetes: 0,
    inertek: [],
    belepok: [],          // [{host, gomb}]
    ui: null,
    nyelvFigyelok: new Set(),
  };

  // ------------------------------------------------------------------------------------------- szövegek
  function T(kulcs, ertekek, ny) {
    const nyelv = ny || A.ny;
    let t = (SZ[nyelv] && SZ[nyelv][kulcs]) || (SZ.hu && SZ.hu[kulcs]) || '';
    if (ertekek) {
      if (Object.prototype.hasOwnProperty.call(ertekek, 'szerzo') && !ertekek.szerzo) t = t.replace(' · {{szerzo}}', '');
      t = t.replace(/\{\{([a-z_]+)\}\}/g, (m, nev) => (Object.prototype.hasOwnProperty.call(ertekek, nev) ? String(ertekek[nev]) : ''));
    }
    return t;
  }

  /** Szöveg darabolása a `[Felirat]` jelölők mentén: [{szoveg}|{gomb}] */
  function darabol(t) {
    const ki = [];
    const re = /\[([^\[\]]{1,80})\]/g;
    let utolso = 0;
    let m;
    while ((m = re.exec(t)) !== null) {
      if (m.index > utolso) ki.push({ szoveg: t.slice(utolso, m.index) });
      ki.push({ gomb: m[1] });
      utolso = re.lastIndex;
    }
    if (utolso < t.length) ki.push({ szoveg: t.slice(utolso) });
    return ki;
  }

  function cimkek(kulcs) {
    const ki = [];
    for (const ny of ['hu', 'ro']) for (const d of darabol(T(kulcs, null, ny))) if (d.gomb) ki.push(d.gomb);
    return ki;
  }

  /** Felirat → művelet. A feliratok a jóváhagyott szövegtáblából (és a ui_text.gombok.json listájából) jönnek. */
  function gombAkcio(felirat) {
    const f = String(felirat).trim();
    const van = (kulcsok) => kulcsok.some((k) => ['hu', 'ro'].some((ny) => T(k, null, ny) === f));
    if (van(['composer.privacy']) || cimkek('notify.consent').includes(f)
        || ['Adatkezelési tájékoztató', 'Politica de confidențialitate'].includes(f)) return { fajta: 'link', cel: UTAK.adatkezeles };
    if (cimkek('welcome.terms_link').includes(f)) return { fajta: 'link', cel: UTAK.feltetelek };
    if (van(['handoff.info_link'])) return { fajta: 'link', cel: UTAK.szallitas };
    if (van(['contact.button'])) return { fajta: 'link', cel: UTAK.kapcsolat };
    if (van(['unavailable.search'])) return { fajta: 'link', cel: UTAK.kereses };
    if (['Elállás a szerződéstől', 'Retragere din contract'].includes(f)) return { fajta: 'link', cel: UTAK.elallas };
    if (['Visszaküldési szabályzat', 'Politica de retur'].includes(f)) return { fajta: 'link', cel: UTAK.visszakuldes };
    if (van(['card.page'])) return { fajta: 'termekoldal' };
    // handoff.after_two_fails: „[Igen, továbbítsd] [Nem, köszönöm]” — páros index = igen, páratlan = nem (HU, RO).
    const ketto = cimkek('handoff.after_two_fails');
    const igen = ketto.filter((x, i) => i % 2 === 0);
    const nem = ketto.filter((x, i) => i % 2 === 1);
    if (van(['composer.handoff', 'handoff.forward', 'chips.ask_yes']) || igen.includes(f)
        || ['E-mail-cím megadása', 'Adaugă adresa de e-mail'].includes(f)) return { fajta: 'atadas' };
    if (van(['chips.ask_no']) || nem.includes(f)) return { fajta: 'elvet' };
    return { fajta: 'uzenet' };
  }

  // ------------------------------------------------------------------------------------------- segédek
  let azonositoSzamlalo = 0;
  const uid = (elotag) => `bai-${elotag}-${++azonositoSzamlalo}`;

  function el(tag, attrs, ...gyerekek) {
    const e = document.createElement(tag);
    if (attrs) {
      for (const k of Object.keys(attrs)) {
        const v = attrs[k];
        if (v === null || v === undefined || v === false) continue;
        if (k === 'class') e.className = v;
        else if (k === 'text') e.textContent = String(v);
        else if (k.slice(0, 2) === 'on' && typeof v === 'function') e.addEventListener(k.slice(2), v);
        else e.setAttribute(k, v === true ? '' : String(v));
      }
    }
    for (const c of gyerekek) if (c !== null && c !== undefined && c !== false) e.append(c);
    return e;
  }

  function ikon(nev, meret, vastagsag) {
    const s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('width', String(meret));
    s.setAttribute('height', String(meret));
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', String(vastagsag || 2));
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    for (const d of IKONOK[nev] || []) {
      const p = document.createElementNS(SVGNS, 'path');
      p.setAttribute('d', d);
      s.append(p);
    }
    return s;
  }

  /** Link-URL ellenőrzése: https, engedélyezett hoszt; a relatív utat a www.booksy.ro-hoz oldjuk fel. */
  function biztonsagosUrl(nyers, hosztok) {
    if (typeof nyers !== 'string' || !nyers || nyers.length > 2048) return null;
    let u;
    try { u = new URL(nyers, ALAP); } catch (e) { return null; }
    if (u.protocol !== 'https:' || u.username || u.password || u.port) return null;
    if (!(hosztok || LINK_HOSZTOK).includes(u.hostname)) return null;
    return u.href;
  }

  function apiAlap(nyers) {
    if (typeof nyers !== 'string') return null;
    if (/^\/[A-Za-z0-9_\-\/]{0,200}$/.test(nyers)) return nyers.replace(/\/+$/, '');
    let u;
    try { u = new URL(nyers); } catch (e) { return null; }
    if (u.protocol !== 'https:' || !API_HOSZTOK.includes(u.hostname) || u.search || u.hash) return null;
    return (u.origin + u.pathname).replace(/\/+$/, '');
  }

  function emailMaszk(email) {
    const s = String(email || '').trim();
    const i = s.lastIndexOf('@');
    if (i < 1) return '••••';
    const helyi = s.slice(0, i);
    return helyi.slice(0, Math.min(2, Math.max(1, helyi.length - 1))) + '••••' + s.slice(i);
  }

  function link(cel, szoveg, osztaly) {
    const href = biztonsagosUrl(cel);
    if (!href) return el('span', { text: szoveg });
    return el('a', { class: osztaly || 'bai-link', href, target: '_blank', rel: 'noopener', text: szoveg });
  }

  /** Szöveg `[Felirat]` linkekkel (csak ismert link-feliratok; minden más felirat sima szövegként marad). */
  function szovegLinkekkel(t) {
    const f = document.createDocumentFragment();
    for (const d of darabol(t)) {
      if (d.szoveg) f.append(document.createTextNode(d.szoveg));
      else {
        const a = gombAkcio(d.gomb);
        if (a.fajta === 'link') f.append(link(a.cel, d.gomb));
        else f.append(document.createTextNode(d.gomb));
      }
    }
    return f;
  }

  /** „Rendelésszám (nem kötelező)” → cím + halvány zárójeles rész (M07). */
  function cimkeSzoveg(t) {
    const i = t.lastIndexOf(' (');
    if (i < 1 || t.slice(-1) !== ')') return document.createTextNode(t);
    const f = document.createDocumentFragment();
    f.append(document.createTextNode(t.slice(0, i) + ' '), el('span', { class: 'bai-nem-kotelezo', text: t.slice(i + 1) }));
    return f;
  }

  const mobil = () => !!(g.matchMedia && g.matchMedia(MOBIL_MQ).matches);
  const csokkentettMozgas = () => !!(g.matchMedia && g.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // ------------------------------------------------------------------------------------------- tároló
  const tarolo = {
    _ls() {
      try { return g.localStorage || null; } catch (e) { return null; }
    },
    olvas(kulcs) {
      try {
        const ls = this._ls();
        if (!ls) return null;
        const v = ls.getItem(kulcs);
        if (!v) return null;
        const o = JSON.parse(v);
        return o && typeof o === 'object' ? o : null;
      } catch (e) {
        return null;
      }
    },
    ir(kulcs, ertek) {
      if (!A.erintve || (kulcs !== KULCS_SESSION && kulcs !== KULCS_CONV)) return false;
      try {
        const ls = this._ls();
        if (!ls) return false;
        ls.setItem(kulcs, JSON.stringify(ertek));
        return true;
      } catch (e) {
        return false;
      }
    },
    torol(kulcs) {
      try {
        const ls = this._ls();
        if (ls) ls.removeItem(kulcs);
      } catch (e) { /* tároló nélkül is működünk */ }
    },
    /** 24 óránál régebbi (vagy sérült, jövőbeli) bejegyzés → mindkét kulcs törlése. */
    lejartTorles(most) {
      let lejart = false;
      for (const k of [KULCS_SESSION, KULCS_CONV]) {
        let nyers = null;
        try { const ls = this._ls(); nyers = ls ? ls.getItem(k) : null; } catch (e) { nyers = null; }
        if (nyers === null) continue;
        const o = this.olvas(k);
        if (!o || typeof o.t !== 'number' || !(most - o.t < ELETTARTAM_MS) || o.t > most + 60000) lejart = true;
      }
      if (lejart) {
        this.torol(KULCS_SESSION);
        this.torol(KULCS_CONV);
      }
      return lejart;
    },
  };

  function munkamenetOlvas() {
    tarolo.lejartTorles(Date.now());
    const m = tarolo.olvas(KULCS_SESSION);
    if (m && typeof m.token === 'string' && m.token.length < 400 && typeof m.lejar === 'number' && Date.now() < m.lejar) return m;
    return null;
  }

  function convMent() {
    const s = tarolo.olvas(KULCS_SESSION);
    const t = s && typeof s.t === 'number' ? s.t : Date.now();
    tarolo.ir(KULCS_CONV, { id: A.conv || null, nyelv: A.ny, t });
  }

  // ------------------------------------------------------------------------------------------- hálózat
  async function api(modszer, ut, torzs, opts) {
    const fejlec = { Accept: 'application/json' };
    if (torzs !== undefined) fejlec['Content-Type'] = 'application/json';
    if (opts && opts.token && A.token) fejlec.Authorization = 'Bearer ' + A.token;
    const r = await fetch(A.api + ut, {
      method: modszer,
      headers: fejlec,
      body: torzs === undefined ? undefined : JSON.stringify(torzs),
      credentials: 'omit',
      cache: 'no-store',
      referrerPolicy: 'no-referrer',
    });
    if (opts && opts.nyers) return r;
    let adat = null;
    try { adat = await r.json(); } catch (e) { adat = null; }
    return { status: r.status, adat: adat && typeof adat === 'object' ? adat : {} };
  }

  function hexKod(buf) {
    const b = new Uint8Array(buf);
    let s = '';
    for (let i = 0; i < b.length; i++) s += (b[i] < 16 ? '0' : '') + b[i].toString(16);
    return s;
  }

  /** ALTCHA (J38): SHA-256(salt + szám) = challenge; a megoldás base64(JSON). Saját szerver, harmadik fél nincs. */
  async function altchaMegold(k) {
    if (!k || k.algorithm !== 'SHA-256' || typeof k.salt !== 'string' || typeof k.challenge !== 'string'
        || typeof k.signature !== 'string') throw new Error('altcha');
    const max = Math.min(Math.max(0, Number(k.maxnumber) || 0), 1000000);
    const kodolo = new TextEncoder();
    const LEPES = 500;
    for (let kezd = 0; kezd <= max; kezd += LEPES) {
      const igeretek = [];
      for (let n = kezd; n < Math.min(kezd + LEPES, max + 1); n++) igeretek.push(g.crypto.subtle.digest('SHA-256', kodolo.encode(k.salt + n)));
      const hashek = await Promise.all(igeretek);
      for (let i = 0; i < hashek.length; i++) {
        if (hexKod(hashek[i]) === k.challenge) {
          const n = kezd + i;
          return g.btoa(JSON.stringify({ algorithm: k.algorithm, challenge: k.challenge, number: n, salt: k.salt, signature: k.signature }));
        }
      }
    }
    throw new Error('altcha');
  }

  /** Egy SSE-blokk („event: …\ndata: …”) feldolgozása; csak az engedett eseménynevek. */
  function sseBlokk(blokk) {
    let nev = 'message';
    const adat = [];
    for (const sor of String(blokk).split('\n')) {
      if (sor.slice(0, 6) === 'event:') nev = sor.slice(6).trim();
      else if (sor.slice(0, 5) === 'data:') adat.push(sor.slice(5).replace(/^ /, ''));
    }
    if (!['allapot', 'valasz', 'vege'].includes(nev)) return null;
    let o = {};
    try { o = adat.length ? JSON.parse(adat.join('\n')) : {}; } catch (e) { return null; }
    return { nev, adat: o && typeof o === 'object' ? o : {} };
  }

  function modValtas(mod) {
    if (!['normal', 'urlap', 'ki'].includes(mod)) return;
    A.mod = mod;
    if (mod === 'ki') belepokEltavolitasa();
    if (mod !== 'normal' && A.ui) urlapNezet(mod);
  }

  async function konfigLeker() {
    const r = await api('GET', '/config');
    if (r.status !== 200) throw new Error('config');
    const mod = ['normal', 'urlap', 'ki'].includes(r.adat.mod) ? r.adat.mod : 'ki';
    const b = r.adat.belepok && typeof r.adat.belepok === 'object' ? r.adat.belepok : {};
    if (mod !== 'ki') {
      A.belepok.slice().forEach((x) => {
        if (b[x.fajta] !== true) belepoEltavolitasa(x);
      });
    }
    return mod;
  }

  async function munkamenetKer(kenyszer) {
    const meglevo = kenyszer ? null : munkamenetOlvas();
    if (meglevo) {
      A.token = meglevo.token;
      const c = tarolo.olvas(KULCS_CONV);
      if (c && typeof c.id === 'string' && c.id.length < 100 && !A.conv) A.conv = c.id;
      return;
    }
    A.token = null;
    const k = await api('GET', '/session/kihivas');
    if (k.status === 503 && k.adat.mod) { modValtas(k.adat.mod); throw new Error('mod'); }
    if (k.status !== 200) throw new Error('kihivas');
    const megoldas = await altchaMegold(k.adat);
    const s = await api('POST', '/session', { altcha: megoldas });
    if ((s.status === 429 || s.status === 503) && s.adat.mod) { modValtas(s.adat.mod); throw new Error('mod'); }
    if (s.status !== 200 || typeof s.adat.token !== 'string') throw new Error('session');
    A.token = s.adat.token;
    const most = Date.now();
    const lejarMp = Number(s.adat.lejar_mp) > 0 ? Number(s.adat.lejar_mp) : 24 * 3600;
    tarolo.ir(KULCS_SESSION, { token: A.token, lejar: most + Math.min(lejarMp * 1000, ELETTARTAM_MS), t: most });
    A.conv = null;
    tarolo.ir(KULCS_CONV, { id: null, nyelv: A.ny, t: most });
  }

  /** Az első érintéskor indul (és csak ekkor): config → (ha nem `ki`) munkamenet. */
  function elokeszit() {
    if (A.elokeszites) return A.elokeszites;
    A.elokeszites = (async () => {
      try {
        const mod = await konfigLeker();
        A.mod = mod;
        if (mod === 'ki') { modValtas('ki'); return; }
        if (mod === 'urlap') { modValtas('urlap'); }
        await munkamenetKer(false);
      } catch (e) {
        // Hálózati hiba: a küldéskor újrapróbáljuk (A.elokeszites törlése).
        A.elokeszites = null;
        throw e;
      }
    })();
    A.elokeszites.catch(() => {});
    return A.elokeszites;
  }

  // ------------------------------------------------------------------------------------------- stílus
  let megosztottLap = null;
  function stilus(gyoker) {
    try {
      if (gyoker.adoptedStyleSheets !== undefined && typeof CSSStyleSheet === 'function' && 'replaceSync' in CSSStyleSheet.prototype) {
        if (!megosztottLap) {
          megosztottLap = new CSSStyleSheet();
          megosztottLap.replaceSync(CSS);
        }
        gyoker.adoptedStyleSheets = [megosztottLap];
        return;
      }
    } catch (e) { /* tartalék lent */ }
    gyoker.append(el('style', { text: CSS }));
  }

  function arnyekHost(hely) {
    const host = document.createElement('div');
    host.setAttribute('data-booksy-ai', '');
    host.setAttribute('data-hely', hely);
    const gyoker = host.attachShadow({ mode: 'open' });
    stilus(gyoker);
    return { host, gyoker };
  }

  // ------------------------------------------------------------------------------------------- belépők
  function pdpCim(t) {
    if (t.available === false) return T('pdp.similar');
    if (t.tipus === 'Könyv') return T('pdp.title.book');
    if (t.tipus === 'Társasjáték') return T('pdp.title.game');
    return T('pdp.title.other');
  }

  function belepoGomb(cim, alcim, forras) {
    const gomb = el('button', { type: 'button', class: 'bai-belepo', 'aria-haspopup': 'dialog', 'aria-expanded': 'false' },
      el('span', { class: 'bai-belepo-ikon' }, ikon('konyv', 18, 1.8)),
      el('span', { class: 'bai-belepo-szoveg' },
        el('span', { class: 'bai-belepo-cim', text: cim }),
        el('span', { class: 'bai-belepo-al', text: alcim })),
      el('span', { class: 'bai-belepo-nyil' }, ikon('nyil', 18, 2)));
    erintesFigyelo(gomb);
    gomb.addEventListener('click', (e) => megnyit({ forras, gomb, billentyu: e.detail === 0 }));
    return gomb;
  }

  function erintesFigyelo(gomb) {
    const elso = () => {
      if (A.cfg && A.cfg.mod === 'ki') return;
      A.erintve = true;
      elokeszit();
    };
    gomb.addEventListener('pointerdown', elso, { passive: true });
    gomb.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') elso(); });
  }

  function belepoEltavolitasa(x) {
    if (A.nyitva && A.megnyito === x.gomb) A.megnyito = null;
    if (x.host && x.host.parentNode && x.fajta !== 'lebego') x.host.remove();
    if (x.fajta === 'lebego' && x.gomb) x.gomb.remove();
    A.belepok = A.belepok.filter((y) => y !== x);
  }

  function belepokEltavolitasa() {
    A.belepok.slice().forEach(belepoEltavolitasa);
  }

  function keresesHelye(talalat) {
    const sajat = document.querySelector('[data-booksy-ai-belepo="kereses"]');
    if (sajat) return { mount: sajat };
    if (talalat === 0) {
      const ures = document.querySelector('.booksy-search-empty');
      if (ures) return { utan: ures };
    } else {
      const lista = document.querySelector('.grid__item--content .collection-grid__wrapper');
      if (lista) return { utan: lista };
    }
    return null;
  }

  function belepokRenderelese() {
    const c = A.cfg;
    if (c.belepok.termekoldal && c.oldal === 'termek' && c.termek) {
      const mount = document.querySelector('[data-booksy-ai-belepo="termek"]');
      if (mount) {
        const { host, gyoker } = arnyekHost('termek');
        const gomb = belepoGomb(pdpCim(c.termek), T('pdp.sub'), c.termek.available === false ? 'hasonlo' : 'termekoldal');
        gyoker.append(gomb);
        mount.append(host);
        A.belepok.push({ fajta: 'termekoldal', host, gomb });
      }
    }
    if (c.belepok.kereses && c.oldal === 'kereses' && c.talalat !== null && c.talalat <= 2) {
      const hely = keresesHelye(c.talalat);
      if (hely) {
        const { host, gyoker } = arnyekHost('kereses');
        const gomb = belepoGomb(T('search.zero'), T('search.sub'), 'kereses');
        gyoker.append(gomb);
        if (hely.mount) hely.mount.append(host);
        else hely.utan.after(host);
        A.belepok.push({ fajta: 'kereses', host, gomb });
      }
    }
    if (c.belepok.lebego) {
      foHost();
      const gomb = el('button', {
        type: 'button', class: 'bai-indito', 'aria-haspopup': 'dialog', 'aria-expanded': 'false',
        'aria-controls': 'bai-panel', 'aria-label': T('launcher.aria'),
      }, ikon('konyv', 24, 1.8), el('span', { text: T('launcher.label') }));
      erintesFigyelo(gomb);
      gomb.addEventListener('click', (e) => megnyit({ forras: 'lebego', gomb, billentyu: e.detail === 0 }));
      A.fo.gyoker.append(gomb);
      A.belepok.push({ fajta: 'lebego', host: A.fo.host, gomb });
      A.indito = gomb;
      inditoFigyeles();
    }
  }

  // ------------------------------------------------------------------------------------------- indító láthatósága
  function bannerLatszik() {
    try {
      const cp = g.Shopify && g.Shopify.customerPrivacy;
      if (!(cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner())) return false;
      // 10-24, élesben mérve: a shouldShowBanner() a döntés UTÁN is true (azt jelenti: a régióban kötelező a sütiablak),
      // ezért egymagában az uniós látogatónak örökre elrejtette a lebegő gombot. A gomb csak addig rejtett, amíg a
      // látogató nem döntött, és az ablak ténylegesen látszik.
      const d = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      if (d && (d.marketing || d.analytics || d.preferences)) return false;
      const ablak = document.getElementById('shopify-pc__banner');
      if (ablak && g.getComputedStyle(ablak).display === 'none') return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  function stickyLatszik() {
    const s = document.getElementById('booksy-pdp-sticky');
    if (!s || !s.classList.contains('is-on')) return false;
    try { return g.getComputedStyle(s).display !== 'none'; } catch (e) { return false; }
  }

  function inditoFrissit() {
    const gomb = A.indito;
    if (!gomb || !gomb.isConnected) return;
    const rejtett = A.nyitva || document.documentElement.classList.contains('js-drawer-open') || bannerLatszik();
    gomb.hidden = rejtett;
    gomb.classList.toggle('bai-emelt', !rejtett && stickyLatszik());
    gomb.classList.toggle('bai-kitér', !rejtett && takar(gomb));
  }

  // 10-25 (2. külső audit, UX-04; élő mérés: 390 px-en 6 görgetési helyzetben a Kosárba gombon / áron ült):
  // amíg az indító egy vásárlási elem fölött van, elhalványul és nem kattintható; a chat a termékoldali belépőről
  // és a görgetés folytatásával továbbra is elérhető.
  const TAKARHATATLAN = 'button[name="add"], button.add-to-cart, .grid-product__price, .product__price, '
    + '.booksy-coupon, [data-booksy-coupon], input[type="number"], .js-qty__wrapper';
  function takar(gomb) {
    if (g.innerWidth >= 768) return false;
    const a = gomb.getBoundingClientRect();
    if (!a.width) return false;
    for (const e of document.querySelectorAll(TAKARHATATLAN)) {
      const b = e.getBoundingClientRect();
      if (b.width && a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top) return true;
    }
    return false;
  }

  function inditoFigyeles() {
    const mo = new MutationObserver(inditoFrissit);
    mo.observe(document.documentElement, { attributeFilter: ['class'] });
    const figyelSticky = () => {
      const s = document.getElementById('booksy-pdp-sticky');
      if (s) mo.observe(s, { attributeFilter: ['class', 'style'] });
    };
    figyelSticky();
    document.addEventListener('visitorConsentCollected', inditoFrissit);
    g.addEventListener('resize', inditoFrissit, { passive: true });
    let kocka = 0;
    g.addEventListener('scroll', () => {
      if (kocka) return;
      kocka = g.requestAnimationFrame(() => { kocka = 0; inditoFrissit(); });
    }, { passive: true });
    if (document.readyState !== 'complete') g.addEventListener('load', () => { figyelSticky(); inditoFrissit(); }, { once: true });
    inditoFrissit();
  }

  // ------------------------------------------------------------------------------------------- panel
  function foHost() {
    if (A.fo) return A.fo;
    A.fo = arnyekHost('fo');
    document.body.append(A.fo.host);
    return A.fo;
  }

  function panelLetrehoz() {
    if (A.ui) return A.ui;
    const { gyoker } = foHost();
    const nevId = 'bai-nev';
    const panel = el('div', { id: 'bai-panel', class: 'bai-panel', role: 'dialog', 'aria-labelledby': nevId, lang: A.ny, hidden: true });
    const nev = el('span', { id: nevId, class: 'bai-sr' });

    const cim = el('div', { id: 'bai-cim', class: 'bai-cim' });
    const alcim = el('div', { id: 'bai-alcim', class: 'bai-alcim' });
    const huGomb = el('button', { type: 'button', class: 'bai-nyelvgomb', lang: 'hu', text: 'HU' });
    const roGomb = el('button', { type: 'button', class: 'bai-nyelvgomb', lang: 'ro', text: 'RO' });
    const nyelvpar = el('div', { class: 'bai-nyelvpar', role: 'group' }, huGomb, roGomb);
    const egyGomb = el('button', { type: 'button', class: 'bai-nyelv-egy' });
    const bezar = el('button', { type: 'button', class: 'bai-bezar' }, ikon('x', 22, 2));
    const fejlec = el('div', { class: 'bai-fejlec' },
      el('div', { class: 'bai-fejlec-ikon' }, ikon('konyv', 20, 1.8)),
      el('div', { class: 'bai-fejlec-szoveg' }, cim, alcim),
      nyelvpar, egyGomb, bezar);

    const log = el('div', { class: 'bai-log', role: 'log', 'aria-live': 'polite' });

    const jelolesId = uid('jeloles');
    const tulHosszuId = uid('hossz');
    const mezoId = uid('mezo');
    const jeloles = el('p', { id: jelolesId, class: 'bai-jeloles' });
    const mezoCimke = el('label', { for: mezoId, class: 'bai-sr' });
    const mezo = el('textarea', { id: mezoId, class: 'bai-szovegmezo', rows: '1', 'aria-describedby': jelolesId, autocomplete: 'off' });
    const kuldGomb = el('button', { type: 'submit', class: 'bai-kuld', 'aria-disabled': 'false' }, ikon('kuld', 20, 2.2));
    const tulHosszu = el('p', { id: tulHosszuId, class: 'bai-hibaszoveg', hidden: true }, ikon('figyel', 14, 2.2), el('span'));
    const atadasGomb = el('button', { type: 'button', class: 'bai-linksor' });
    // 10-26 (tulaj: „A — Rövid”): az adatkezelés 2. rétege a chatbe nyílik (a teljes, változatlan tájékoztató)
    const adatkezeles = el('button', { type: 'button', class: 'bai-adatkezeles' });
    adatkezeles.addEventListener('click', () => tudnivalok());
    const bevitel = el('form', { class: 'bai-bevitel', novalidate: true },
      el('div', { class: 'bai-bevitel-sor' }, mezoCimke, mezo, kuldGomb),
      tulHosszu,
      jeloles,
      el('div', { class: 'bai-bevitel-also' }, atadasGomb, adatkezeles));

    const csevego = el('div', { class: 'bai-csevego', style: 'display:contents' }, log, bevitel);
    const urlapTarto = el('div', { class: 'bai-urlapnezet', hidden: true });
    panel.append(nev, fejlec, csevego, urlapTarto);
    gyoker.append(panel);

    const ui = { panel, nev, cim, alcim, huGomb, roGomb, nyelvpar, egyGomb, bezar, log, jeloles, mezoCimke, mezo, kuldGomb,
      tulHosszu, tulHosszuId, jelolesId, atadasGomb, adatkezeles, bevitel, csevego, urlapTarto, udvozolve: false };
    A.ui = ui;

    huGomb.addEventListener('click', () => nyelvValt('hu'));
    roGomb.addEventListener('click', () => nyelvValt('ro'));
    egyGomb.addEventListener('click', () => nyelvValt(A.ny === 'hu' ? 'ro' : 'hu'));
    bezar.addEventListener('click', () => zar());
    panel.addEventListener('keydown', panelBillentyu);
    bevitel.addEventListener('submit', (e) => { e.preventDefault(); kuldesMezobol(); });
    mezo.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
        e.preventDefault();
        kuldesMezobol();
      }
    });
    mezo.addEventListener('input', () => { mezoMeretez(); hosszEllenoriz(); });
    atadasGomb.addEventListener('click', () => kuld(T('composer.handoff')));

    feliratok();
    return ui;
  }

  function feliratok() {
    const ui = A.ui;
    if (!ui) return;
    ui.panel.setAttribute('lang', A.ny);
    ui.nev.textContent = T('header.dialog_name');
    ui.cim.textContent = T('header.title');
    ui.alcim.textContent = T('header.sub');
    ui.nyelvpar.setAttribute('aria-label', T('header.lang'));
    ui.huGomb.setAttribute('aria-label', T('header.lang_hu'));
    ui.roGomb.setAttribute('aria-label', T('header.lang_ro'));
    ui.huGomb.setAttribute('aria-pressed', A.ny === 'hu' ? 'true' : 'false');
    ui.roGomb.setAttribute('aria-pressed', A.ny === 'ro' ? 'true' : 'false');
    const masik = A.ny === 'hu' ? 'ro' : 'hu';
    ui.egyGomb.textContent = masik.toUpperCase();
    ui.egyGomb.setAttribute('lang', masik);
    ui.egyGomb.setAttribute('aria-label', T(masik === 'hu' ? 'header.lang_hu' : 'header.lang_ro'));
    ui.bezar.setAttribute('aria-label', T('header.close'));
    // 10-26: az adatkezelés első rétege (AI-jelzés, adatkezelő, külső AI-szolgáltató) egy sorban, végig látható
    ui.jeloles.textContent = T('composer.notice');
    ui.mezoCimke.textContent = T('composer.label');
    ui.mezo.setAttribute('placeholder', T('composer.placeholder'));
    ui.kuldGomb.setAttribute('aria-label', T('composer.send'));
    ui.tulHosszu.lastChild.textContent = T('chat.too_long');
    ui.atadasGomb.textContent = T('composer.handoff');
    ui.adatkezeles.textContent = T('composer.privacy_more');
    if (A.indito) {
      A.indito.setAttribute('aria-label', T('launcher.aria'));
      A.indito.lastChild.textContent = T('launcher.label');
    }
  }

  function nyelvValt(ny) {
    if (ny !== 'hu' && ny !== 'ro' || ny === A.ny) return;
    A.ny = ny;
    feliratok();
    // Nyitott űrlapok újraépítése az új nyelven, ÜRESEN (a hozzájárulás nem öröklődik; 5. pont 1.).
    for (const f of Array.from(A.nyelvFigyelok)) f();
    if (A.ui && !A.ui.urlapTarto.hidden && A.mod && A.mod !== 'normal') urlapNezet(A.mod);
    // 10-26 (élő mérés): ha még csak az üdvözlés látszik, az is az új nyelven jelenjen meg (a gombokkal együtt)
    if (A.ui && A.ui.udvozolve && !A.utolsoVevo) {
      A.ui.log.replaceChildren();
      udvozles();
    }
    if (A.token) convMent();
  }

  function mezoMeretez() {
    const m = A.ui.mezo;
    m.style.height = 'auto';
    m.style.height = Math.min(Math.max(m.scrollHeight + 2, 48), 120) + 'px';
  }

  function hosszEllenoriz() {
    const ui = A.ui;
    const tul = ui.mezo.value.length > MAX_UZENET;
    ui.tulHosszu.hidden = !tul;
    if (tul) {
      ui.mezo.setAttribute('aria-invalid', 'true');
      ui.mezo.setAttribute('aria-describedby', ui.jelolesId + ' ' + ui.tulHosszuId);
    } else {
      ui.mezo.removeAttribute('aria-invalid');
      ui.mezo.setAttribute('aria-describedby', ui.jelolesId);
    }
    return !tul;
  }

  /** Használati mérés (10-24): csak az esemény neve megy, napi darabszámként tárolva — azonosító és süti nincs. */
  function esemeny(nev) {
    if (!A.api) return;
    try {
      g.fetch(A.api + '/esemeny', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ nev }),
        keepalive: true, credentials: 'omit',
      }).catch(() => {});
    } catch (e) { /* a mérés nem zavarhatja a vevőt */ }
  }

  function kuldGombAllapot() {
    if (A.ui) A.ui.kuldGomb.setAttribute('aria-disabled', A.foglalt ? 'true' : 'false');
  }

  // ------------------------------------------------------------------------------------------- nyitás / zárás
  function megnyit(o) {
    if (A.cfg && A.cfg.mod === 'ki') return;
    A.erintve = true;
    elokeszit();
    const ui = panelLetrehoz();
    if (A.nyitva) {
      if (o && o.forras === 'kereses') elotolt();
      return;
    }
    A.megnyito = (o && o.gomb) || null;
    A.belepesi = (o && o.forras) || 'egyeb';
    A.nyitva = true;
    ui.panel.hidden = false;
    esemeny('megnyitas');
    document.documentElement.classList.add('booksy-ai-open');
    A.belepok.forEach((x) => x.gomb && x.gomb.setAttribute('aria-expanded', x.gomb === A.megnyito ? 'true' : 'false'));
    elrendezes();
    inditoFrissit();
    try {
      g.history.pushState(Object.assign({}, g.history.state || {}, { booksyAi: 1 }), '');
      A.tortenet = true;
    } catch (e) { A.tortenet = false; }

    if (A.mod && A.mod !== 'normal') urlapNezet(A.mod);
    else if (!ui.udvozolve) udvozles();
    if (o && (o.forras === 'termekoldal' || o.forras === 'hasonlo') && A.cfg.termek && !ui.termekVisszhang) {
      ui.termekVisszhang = true;
      logba(visszhang(T('pdp.echo', { cim: A.cfg.termek.cim })));
    }
    if (o && o.forras === 'kereses') elotolt();

    const fokusz = () => {
      if (!A.nyitva) return;
      if (o && o.forras === 'kereses' && !ui.csevego.hidden) { ui.mezo.focus(); return; }
      if (o && o.billentyu) {
        const botok = ui.log.querySelectorAll('.bai-bot');
        const utolso = botok[botok.length - 1];
        if (utolso && !ui.csevego.hidden) { utolso.focus(); return; }
      }
      ui.bezar.focus();
    };
    fokusz();   // szinkron: a rAF háttérlapon nem fut, és a panel már látható (hidden levéve)
  }

  function elotolt() {
    const ui = A.ui;
    let q = '';
    try { q = new URLSearchParams(g.location.search).get('q') || ''; } catch (e) { q = ''; }
    q = q.trim().slice(0, MAX_UZENET);
    if (q && !ui.mezo.value) {
      ui.mezo.value = q;   // csak előtöltés; automatikus küldés nincs (4. pont WP4)
      mezoMeretez();
    }
  }

  function zar(opts) {
    if (!A.nyitva) return;
    const ui = A.ui;
    A.nyitva = false;
    ui.panel.hidden = true;
    document.documentElement.classList.remove('booksy-ai-open');
    mobilKi();
    A.belepok.forEach((x) => x.gomb && x.gomb.setAttribute('aria-expanded', 'false'));
    inditoFrissit();
    if (A.tortenet && !(opts && opts.popstate)) {
      A.tortenet = false;
      try { if (g.history.state && g.history.state.booksyAi) g.history.back(); } catch (e) { /* nincs teendő */ }
    }
    A.tortenet = false;
    const vissza = A.megnyito && A.megnyito.isConnected ? A.megnyito : (A.indito && A.indito.isConnected && !A.indito.hidden ? A.indito : null);
    if (vissza) vissza.focus();
  }

  function elrendezes() {
    if (!A.ui || !A.nyitva) return;
    const p = A.ui.panel;
    if (mobil()) {
      p.setAttribute('data-mobil', '');
      p.setAttribute('aria-modal', 'true');
      mobilBe();
    } else {
      p.removeAttribute('data-mobil');
      p.removeAttribute('aria-modal');
      mobilKi();
    }
  }

  function vvFrissit() {
    if (!A.ui || !A.nyitva || !mobil()) return;
    const p = A.ui.panel;
    const vv = g.visualViewport;
    if (vv) {
      p.style.height = vv.height + 'px';
      p.style.transform = 'translateY(' + vv.offsetTop + 'px)';
    } else {
      p.style.height = g.innerHeight + 'px';
      p.style.transform = '';
    }
  }

  function mobilBe() {
    if (A.mobilAktiv) { vvFrissit(); return; }
    A.mobilAktiv = true;
    A.gorgetes = g.scrollY || g.pageYOffset || 0;
    document.documentElement.style.overflow = 'hidden';
    A.inertek = [];
    for (const gy of Array.from(document.body.children)) {
      if (gy === A.fo.host || gy.inert || gy.tagName === 'SCRIPT') continue;
      gy.inert = true;
      A.inertek.push(gy);
    }
    if (g.visualViewport) {
      g.visualViewport.addEventListener('resize', vvFrissit);
      g.visualViewport.addEventListener('scroll', vvFrissit);
    } else {
      g.addEventListener('resize', vvFrissit);
    }
    vvFrissit();
  }

  function mobilKi() {
    if (!A.mobilAktiv) return;
    A.mobilAktiv = false;
    for (const e of A.inertek) e.inert = false;
    A.inertek = [];
    document.documentElement.style.overflow = '';
    if (g.visualViewport) {
      g.visualViewport.removeEventListener('resize', vvFrissit);
      g.visualViewport.removeEventListener('scroll', vvFrissit);
    } else {
      g.removeEventListener('resize', vvFrissit);
    }
    if (A.ui) {
      A.ui.panel.style.height = '';
      A.ui.panel.style.transform = '';
    }
    try { g.scrollTo(0, A.gorgetes); } catch (e) { /* nincs teendő */ }
  }

  function fokuszalhatok() {
    const gy = A.ui.panel;
    return Array.from(gy.querySelectorAll('button, a[href], input, textarea, select, [tabindex]:not([tabindex="-1"])'))
      .filter((e) => !e.hidden && e.getAttribute('tabindex') !== '-1' && e.getClientRects().length > 0);
  }

  function panelBillentyu(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      zar();
      return;
    }
    if (e.key === 'Tab' && A.ui.panel.hasAttribute('data-mobil')) {
      const f = fokuszalhatok();
      if (!f.length) return;
      // A léptetést a widget végzi minden Tab-ra: a WebKit (Safari) natív Tab-ja alapból kihagyja a gombokat és a
      // linkeket, így a fókusz kicsúszna a panelből (Playwright WebKit-mérés, 2026-10-24).
      const aktiv = A.fo.gyoker.activeElement;
      const i = f.indexOf(aktiv);
      e.preventDefault();
      if (e.shiftKey) f[i <= 0 ? f.length - 1 : i - 1].focus();
      else f[i === -1 || i === f.length - 1 ? 0 : i + 1].focus();
    }
  }

  // ------------------------------------------------------------------------------------------- log-építők
  function logba(csomopont, cel) {
    const log = cel || A.ui.log;
    const alul = log.scrollHeight - log.scrollTop - log.clientHeight < 32;
    log.append(csomopont);
    if (alul || log.childElementCount <= 3) log.scrollTop = log.scrollHeight;
    return csomopont;
  }

  function botBuborek(osztaly) {
    const b = el('div', { class: 'bai-bot' + (osztaly ? ' ' + osztaly : ''), 'data-ai-generated': 'true', tabindex: '-1' });
    b.append(el('span', { class: 'bai-sr', text: T('sr.bot_prefix') + ' ' }));
    return b;
  }

  function bekezdesek(cel, szoveg) {
    const reszek = String(szoveg || '').split(/\n{2,}/).map((s) => s.trim()).filter(Boolean);
    for (const r of reszek) cel.append(el('p', { text: r }));
  }

  const visszhang = (szoveg) => el('div', { class: 'bai-visszhang', text: szoveg });

  function chipCsoport(feliratok, cimke, akciok, kartyak) {
    const csop = el('div', { class: 'bai-chipek', role: 'group', 'aria-label': cimke });
    for (const f of feliratok) {
      const b = el('button', { type: 'button', class: 'bai-chip', text: f });
      b.addEventListener('click', () => gombKezeles(f, b, akciok || [], kartyak || [], csop));
      csop.append(b);
    }
    return csop;
  }

  function udvozles() {
    const ui = A.ui;
    ui.udvozolve = true;
    const b = botBuborek();
    // 10-26 (tulaj: „A — Rövid”): egy mondat + 4 gomb; az AI-jelzés a fejlécben és a mező alatti sorban, a teljes
    // tájékoztató (welcome.1/2, adatkezelés, tiltakozás, feltételek) SZÓ SZERINT az „Adatkezelés és jogaid” rétegben.
    b.append(el('p', { text: T('welcome.short') }));
    logba(b);
    const kezdo = T('chips.start').split(' · ').map((s) => s.trim()).filter(Boolean);
    logba(chipCsoport(kezdo, T('chips.start_label')));
    ui.log.scrollTop = 0;
  }

  function tudnivalok() {
    const ui = A.ui;
    const b = botBuborek();
    b.append(el('p', { text: T('welcome.1') }), el('p', { text: T('welcome.2') }));
    // 10-25 (2. külső audit, UX-01): rétegzett adatkezelési tájékoztató — a kötelező tartalom SZÓ SZERINT megmarad;
    // az adatkezelő és a „ne írj személyes adatot” kérés mindig látszik, a többi egy kattintással lenyílik.
    const mondatok = T('welcome.privacy').split(/(?<=\.)\s+(?=[A-ZÁÉÍÓÖŐÚÜŰĂÂÎȘȚ])/);
    const latszo = el('p', { class: 'bai-apro bai-elvalaszto' }, mondatok.slice(0, 2).join(' '));
    const tovabbi = el('p', { class: 'bai-apro' });
    tovabbi.append(szovegLinkekkel(mondatok.slice(2).join(' ')));
    b.append(latszo, tovabbi, el('p', { class: 'bai-apro', text: T('welcome.objection') }));
    if (A.cfg.feltetelek) b.append(link(UTAK.feltetelek, darabol(T('welcome.terms_link')).map((d) => d.gomb || d.szoveg).join('').trim(), 'bai-linksor'));
    logba(b);
    const log = ui.log;
    log.scrollTop = Math.max(0, b.offsetTop - log.offsetTop - 8);
  }

  function gepelJelzo() {
    const jelzo = el('div', { class: 'bai-gepel' },
      el('span', { class: 'bai-pottyok', 'aria-hidden': 'true' }, el('span'), el('span'), el('span')),
      el('span', { text: T('status.searching') }));
    const csontvaz = el('div', { class: 'bai-csontvaz', 'aria-hidden': 'true' },
      el('div', { class: 'bai-csontvaz-borito' }),
      el('div', { class: 'bai-csontvaz-sorok' }, el('span'), el('span'), el('span'), el('span')));
    logba(jelzo);
    logba(csontvaz);
    return { torol() { jelzo.remove(); csontvaz.remove(); } };
  }

  function hibaBuborek(szoveg, ujraFn) {
    const b = botBuborek();
    b.append(el('p', { text: szoveg }));
    logba(b);
    const csop = el('div', { class: 'bai-chipek', role: 'group', 'aria-label': T('chips.after_label') });
    if (ujraFn) {
      const u = el('button', { type: 'button', class: 'bai-chip', text: T('chat.retry') });
      u.addEventListener('click', () => { csop.remove(); ujraFn(); });
      csop.append(u);
    }
    // 10-25 (2. külső audit, AI-03): valódi hibánál újrapróba + kereső + emberi segítség, nem csak az utóbbi
    csop.append(link(UTAK.kereses, T('unavailable.search'), 'bai-chip'));
    const k = el('button', { type: 'button', class: 'bai-chip', text: T('composer.handoff') });
    k.addEventListener('click', () => { csop.remove(); kuld(T('composer.handoff')); });
    csop.append(k);
    logba(csop);
  }

  function hirdetes(szoveg) {
    // Rejtett bejelentés a logban (pl. sikeres kosárba tétel).
    logba(el('div', { class: 'bai-sr', text: szoveg }));
  }

  // ------------------------------------------------------------------------------------------- küldés
  function kuldesMezobol() {
    const ui = A.ui;
    if (A.foglalt) return;    // a vége eseményig a küldés gomb és az Enter nem csinál semmit
    if (!hosszEllenoriz()) { ui.mezo.focus(); return; }
    const szoveg = ui.mezo.value.trim();
    if (!szoveg) return;
    ui.mezo.value = '';
    mezoMeretez();
    kuld(szoveg);
  }

  async function kuld(szoveg) {
    szoveg = String(szoveg || '').trim();
    if (!szoveg || A.foglalt || !A.ui) return;
    if (szoveg.length > MAX_UZENET) return;
    A.foglalt = true;
    kuldGombAllapot();
    A.utolsoVevo = szoveg;
    logba(el('div', { class: 'bai-vevo', text: szoveg }));
    const jelzo = gepelJelzo();
    try {
      await elokeszit();
      if (A.mod && A.mod !== 'normal') return;
      await chat(szoveg, 0);
    } catch (e) {
      if (A.mod === 'normal' || A.mod === null) {
        const offline = g.navigator && g.navigator.onLine === false;
        hibaBuborek(T(offline ? 'chat.offline' : 'chat.err'), () => kuld(szoveg));
      }
    } finally {
      jelzo.torol();
      A.foglalt = false;
      kuldGombAllapot();
    }
  }

  async function chat(szoveg, probalkozas) {
    const torzs = {
      uzenet: szoveg,
      nyelv: A.ny,
      belepesi_pont: A.belepesi,
    };
    if (A.conv) torzs.beszelgetes = A.conv;
    // 10-25 (élő mérés, R06): a termékoldalon a lebegő gombbal nyitott chat is az oldal termékére vonatkozik
    if (A.cfg.termek && ['termekoldal', 'hasonlo', 'lebego'].includes(A.belepesi)) torzs.termek = A.cfg.termek.id;
    const r = await api('POST', '/chat', torzs, { token: true, nyers: true });
    if (!r.ok) {
      let adat = {};
      try { adat = await r.json(); } catch (e) { adat = {}; }
      if (adat && adat.mod && (r.status === 503 || r.status === 429)) { modValtas(adat.mod); return; }
      if (r.status === 401 && probalkozas < 1) { await munkamenetKer(true); return chat(szoveg, probalkozas + 1); }
      if (r.status === 404 && adat && adat.hiba === 'nincs' && probalkozas < 1) { A.conv = null; convMent(); return chat(szoveg, probalkozas + 1); }
      throw new Error('chat ' + r.status);
    }
    const olvaso = r.body.getReader();
    const dekoder = new TextDecoder();
    let puffer = '';
    let kapott = false;
    for (;;) {
      const { value, done } = await olvaso.read();
      if (done) break;
      puffer += dekoder.decode(value, { stream: true }).replace(/\r\n/g, '\n');
      let i;
      while ((i = puffer.indexOf('\n\n')) >= 0) {
        const blokk = puffer.slice(0, i);
        puffer = puffer.slice(i + 2);
        const ev = sseBlokk(blokk);
        if (!ev) continue;
        if (ev.nev === 'valasz') { kapott = true; valaszMegjelenit(ev.adat); }
        else if (ev.nev === 'vege' && ev.adat.mod) modValtas(ev.adat.mod);
      }
    }
    if (!kapott && A.mod !== 'ki') throw new Error('nincs valasz');
  }

  // ------------------------------------------------------------------------------------------- válasz
  function jelvenyFajta(k) {
    const kind = k && typeof k.badge_kind === 'string' ? k.badge_kind : '';
    if (kind === 'instock' || kind === 'supplier' || kind === 'out') return kind;
    if (kind === 'voucher') return 'neutral';
    const j = k && typeof k.jelveny === 'string' ? k.jelveny : '';
    // A JS-regex `\b`-je az ékezetes betűt nem tekinti szókaraktérnek („kapható”), ezért explicit határ kell.
    const eleje = (szo) => j === szo || j.slice(0, szo.length + 1) === szo + ' ';
    if (eleje('Raktáron')) return 'instock';
    if (eleje('Beszállítótól')) return 'supplier';
    if (eleje('Jelenleg nem kapható') || eleje('Elfogyott')) return 'out';
    return 'neutral';
  }

  function valaszMegjelenit(v) {
    if (!v || typeof v !== 'object') return;
    if (v.hiba === true && A.utolsoVevo) {
      // szerveroldali hiba (modell / szolgáltató): a kérdés nem vész el, egy kattintással újraküldhető
      const kerdes = A.utolsoVevo;
      hibaBuborek(typeof v.szoveg === 'string' && v.szoveg ? v.szoveg : T('chat.err'), () => kuld(kerdes));
      return;
    }
    if (typeof v.beszelgetes === 'string' && v.beszelgetes && v.beszelgetes.length < 100) {
      if (A.conv !== v.beszelgetes) { A.conv = v.beszelgetes; convMent(); }
    }
    // 10-25 (2. külső audit, AI-04): ha a szerver a vevő nyelvét felismerte (román kérdés HU felületen), az EGÉSZ chat-
    // felület vált (fejléc, mező, gombok); a beszélgetés és a kontextus ugyanaz marad.
    if ((v.nyelv === 'hu' || v.nyelv === 'ro') && v.nyelv !== A.ny) nyelvValt(v.nyelv);
    const kartyak = Array.isArray(v.kartyak) ? v.kartyak.filter((k) => k && typeof k === 'object').slice(0, 6) : [];
    const akciok = Array.isArray(v.akciok) ? v.akciok.filter((a) => a && typeof a === 'object') : [];
    const gombok = Array.isArray(v.gombok) ? v.gombok.filter((s) => typeof s === 'string' && s.length <= 80).slice(0, 6) : [];

    const b = botBuborek();
    bekezdesek(b, typeof v.szoveg === 'string' ? v.szoveg : '');
    if (kartyak.length) b.append(el('span', { class: 'bai-sr', text: kartyak.length === 1 ? T('card.count.one') : T('card.count.many', { n: kartyak.length }) }));

    const buborekGombok = el('div', { class: 'bai-bot-gombok' });
    const chipek = [];
    for (const f of gombok) {
      const a = gombAkcio(f);
      if (a.fajta === 'link') {
        buborekGombok.append(link(a.cel, f, 'bai-gomb bai-gomb-keretes'));
      } else if (a.fajta === 'termekoldal') {
        const url = (kartyak[0] && biztonsagosUrl(kartyak[0].url)) || termekoldalUrl();
        if (url) buborekGombok.append(link(url, f, 'bai-gomb bai-gomb-keretes'));
      } else if (a.fajta === 'atadas' && !['hu', 'ro'].some((ny) => T('composer.handoff', null, ny) === f)
          && akciok.some((x) => x.fajta === 'atadas')) {
        // „Továbbítsd a kérdésem” / „Igen, továbbítsd”: teli gomb a buborékban (M07); a „Beszélnék egy kollégával”
        // chip marad (M04), de akcióval ugyanígy az űrlapot nyitja.
        const gomb = el('button', { type: 'button', class: 'bai-gomb bai-gomb-teli', 'aria-expanded': 'false', text: f });
        gomb.addEventListener('click', () => gombKezeles(f, gomb, akciok, kartyak, null));
        buborekGombok.prepend(gomb);
      } else {
        chipek.push(f);
      }
    }
    if (buborekGombok.childElementCount) b.append(buborekGombok);
    logba(b);

    if (kartyak.length) {
      const tarto = el('div', { class: 'bai-kartyak', 'aria-live': 'off' });
      for (const k of kartyak) tarto.append(kartya(k, akciok));
      logba(tarto);
    }
    if (chipek.length) logba(chipCsoport(chipek, T('chips.after_label'), akciok, kartyak));
    // 10-24 (teljes audit): kártyás válasz után a lista aljára görgettünk, és a válasz szövege kicsúszott —
    // most a válasz elejére görgetünk (a kártyák alatta olvashatók tovább).
    // 10-25 (UX-01): akkor is a válasz elejére, ha a szöveg magában hosszabb a látható résznél
    const log = A.ui.log;
    const eleje = Math.max(0, b.offsetTop - log.offsetTop - 8);
    if (kartyak.length || log.scrollHeight - eleje > log.clientHeight) log.scrollTop = eleje;
  }

  function termekoldalUrl() {
    const t = A.cfg && A.cfg.termek;
    return t && t.handle ? biztonsagosUrl('/products/' + t.handle) : null;
  }

  function gombKezeles(felirat, gomb, akciok, kartyak, csoport) {
    if (A.foglalt) return;
    const a = gombAkcio(felirat);
    if (a.fajta === 'atadas') {
      const akcio = akciok.find((x) => x.fajta === 'atadas' && typeof x.nonce === 'string');
      if (akcio) {
        if (csoport) csoport.remove();
        atadasUrlap(akcio, gomb);
        return;
      }
    }
    if (a.fajta === 'elvet') { if (csoport) csoport.remove(); return; }
    if (csoport) csoport.remove();
    kuld(felirat);
  }

  // ------------------------------------------------------------------------------------------- kártya
  function kartya(k, akciok) {
    const fajta = jelvenyFajta(k);
    const tartalek = k.allapot !== 'ok';
    const url = biztonsagosUrl(k.url);
    const cim = typeof k.cim === 'string' ? k.cim.slice(0, 200) : '';
    const doboz = el('article', { class: 'bai-kartya', 'data-ai-card': 'true' });

    const kepUrl = biztonsagosUrl(k.kep, KEP_HOSZTOK);
    const borito = kepUrl
      ? el('img', { class: 'bai-borito', src: kepUrl, alt: '', loading: 'lazy', decoding: 'async', referrerpolicy: 'no-referrer' })
      : el('div', { class: 'bai-borito', 'aria-hidden': 'true', text: cim.slice(0, 40) });

    const adat = el('div', { class: 'bai-kartya-adat' });
    if (typeof k.szerzo === 'string' && k.szerzo) adat.append(el('div', { class: 'bai-szerzo', lang: 'hu', text: k.szerzo.slice(0, 120) }));
    adat.append(el('p', { class: 'bai-kartya-cim', lang: 'hu', text: cim }));
    if (typeof k.nyelv === 'string' && k.nyelv && !/^magyar$/i.test(k.nyelv)) adat.append(el('div', { class: 'bai-nyelvsor', text: T('card.lang', { nyelv: k.nyelv.slice(0, 40) }) }));

    if (!tartalek) {
      const ar = el('div', { class: 'bai-arblokk' });
      if (typeof k.ar === 'string' && k.ar) ar.append(el('div', { class: 'bai-ar', text: k.ar }));
      if (typeof k.jelveny === 'string' && k.jelveny) {
        const j = el('div', { class: 'bai-jelveny bai-j-' + fajta });
        if (fajta === 'instock') j.append(el('span', { class: 'bai-potty-zold', 'aria-hidden': 'true' }));
        else if (fajta === 'supplier') j.append(ikon('doboz', 13, 2));
        else if (fajta === 'out') j.append(ikon('tiltott', 13, 2));
        j.append(el('span', { lang: 'hu', text: k.jelveny }));
        ar.append(j);
        const ro = typeof k.jelveny_ro === 'string' && k.jelveny_ro ? k.jelveny_ro : (A.ny === 'ro' ? BADGE_RO[k.jelveny] : null);
        if (A.ny === 'ro' && ro) ar.append(el('div', { class: 'bai-romagy', text: '(' + ro + ')' }));
      }
      adat.append(ar);
    } else if (url) {
      adat.append(link(url, T('card.fallback'), 'bai-tartalek'));
    }
    doboz.append(el('div', { class: 'bai-kartya-fo' }, borito, adat));

    if (typeof k.miert === 'string' && k.miert) {
      doboz.append(el('p', { class: 'bai-miert' }, el('strong', { text: T('card.why') }), ' ' + k.miert.slice(0, 300)));
    }

    if (!tartalek) {
      const sor = el('div', { class: 'bai-kartya-gombok' });
      if (url) {
        const oldal = link(url, T('card.page'), 'bai-gomb bai-gomb-keretes');
        oldal.addEventListener('click', () => esemeny('kartya_oldal'));
        sor.append(oldal);
      }
      const ertesites = akciok.find((a) => a.fajta === 'ertesites' && a.termek === k.id && typeof a.nonce === 'string');
      const vid = Number.isSafeInteger(k.variant_id) && k.variant_id > 0 ? k.variant_id : null;
      if (fajta === 'out' && ertesites) {
        const gomb = el('button', { type: 'button', class: 'bai-gomb bai-gomb-teli', 'aria-expanded': 'false', text: T('card.notify') });
        gomb.addEventListener('click', () => ertesitesUrlap(k, ertesites, gomb, doboz));
        sor.append(gomb);
      } else if (fajta !== 'out' && vid) {
        const gomb = el('button', { type: 'button', class: 'bai-gomb bai-gomb-teli', text: T('card.cart') });
        gomb.addEventListener('click', () => kosarba(vid, cim, gomb, sor, doboz));
        sor.append(gomb);
      }
      if (sor.childElementCount) doboz.append(sor);
    }
    return doboz;
  }

  async function kosarba(vid, cim, gomb, sor, doboz) {
    if (gomb.getAttribute('aria-busy') === 'true') return;
    const regiHiba = doboz.querySelector('.bai-kartya-hiba');
    if (regiHiba) regiHiba.remove();
    gomb.setAttribute('aria-busy', 'true');
    gomb.textContent = T('card.cart_adding');
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: vid, quantity: 1 }),
      });
      if (!r.ok) throw new Error('kosar ' + r.status);
      const kesz = el('div', { class: 'bai-gomb bai-kosarban' }, ikon('pipa', 16, 2.4), el('span', { text: T('card.cart_added') }));
      gomb.replaceWith(kesz);
      const linkek = el('div', { class: 'bai-kosar-linkek' }, link(UTAK.kosar, T('card.cart_open')));
      const kosarUt = '/cart/' + vid + ':1';
      if (KOSARLINK_MINTA.test(kosarUt)) linkek.append(link(kosarUt, T('card.cart_link')));
      sor.after(linkek);
      hirdetes(T('card.cart_added') + ': ' + cim);
      esemeny('kosarba');
      try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) { /* a téma eseménye (F0 0.5) */ }
    } catch (e) {
      gomb.setAttribute('aria-busy', 'false');
      gomb.textContent = T('card.cart');
      doboz.append(el('p', { class: 'bai-kartya-hiba', text: T('card.cart_fail') }));
    }
  }

  // ------------------------------------------------------------------------------------------- űrlap-segédek
  function mezoHiba(input, hibaP, szoveg, alapDesc) {
    hibaP.lastChild.textContent = szoveg;
    hibaP.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', (alapDesc ? alapDesc + ' ' : '') + hibaP.id);
  }

  function mezoHibaTorol(input, hibaP, alapDesc) {
    hibaP.hidden = true;
    input.removeAttribute('aria-invalid');
    if (alapDesc) input.setAttribute('aria-describedby', alapDesc);
    else input.removeAttribute('aria-describedby');
  }

  const hibaP = (id, extra) => el('p', { id, class: 'bai-hibaszoveg' + (extra ? ' ' + extra : ''), hidden: true }, ikon('figyel', 14, 2.2), el('span'));

  function kuldoGombFoglalt(gomb, foglalt, felirat) {
    gomb.setAttribute('aria-busy', foglalt ? 'true' : 'false');
    gomb.textContent = foglalt ? T('form.sending') : felirat;
  }

  function sikerBuborek(fo, tovabbiak) {
    const b = botBuborek('bai-siker');
    const sor = el('div', { class: 'bai-siker-sor' }, el('span', { class: 'bai-siker-ikon' }, ikon('pipa', 16, 2.4)), el('p', { text: fo }));
    b.append(sor);
    for (const t of tovabbiak || []) b.append(t);
    return b;
  }

  function nyelvFigyelo(fn) {
    A.nyelvFigyelok.add(fn);
    return () => A.nyelvFigyelok.delete(fn);
  }

  async function munkamenetesKeres(ut, torzs) {
    let r = await api('POST', ut, torzs, { token: true });
    if (r.status === 401 && r.adat.hiba === 'munkamenet') {
      await munkamenetKer(true);
      r = await api('POST', ut, torzs, { token: true });
    }
    return r;
  }

  // ------------------------------------------------------------------------------------------- értesítés (M05/M06)
  function ertesitesUrlap(k, akcio, gomb, doboz) {
    const ui = A.ui;
    if (ui.ertesitesUrlap && ui.ertesitesUrlap.isConnected) { ui.ertesitesUrlap.querySelector('input').focus(); return; }
    const cim = typeof k.cim === 'string' ? k.cim : '';
    const tarto = doboz.parentNode;

    function epit() {
      const id = uid('ert');
      const emailId = uid('ert-email');
      const emailHibaId = uid('ert-email-hiba');
      const pipaId = uid('ert-hozz');
      const segedId = uid('ert-seged');
      const pipaHibaId = uid('ert-hozz-hiba');
      const email = el('input', { id: emailId, class: 'bai-input', type: 'email', autocomplete: 'email', inputmode: 'email', placeholder: T('notify.email_ph'), maxlength: '254' });
      const emailHiba = hibaP(emailHibaId);
      // A jelölőnégyzet MINDIG üresen jön létre; állapotát nem tároljuk és nem örököljük (5. pont 1.).
      const pipa = el('input', { id: pipaId, type: 'checkbox', 'aria-describedby': segedId });
      const pipaSzoveg = el('span');
      pipaSzoveg.append(szovegLinkekkel(T('notify.consent')));
      const pipaHiba = hibaP(pipaHibaId, 'bai-behuzott');
      const kuldo = el('button', { type: 'submit', class: 'bai-urlap-gomb', 'aria-busy': 'false', text: T('notify.button') });
      const termek = el('div', { class: 'bai-termeksor' }, T('notify.product') + ' ', el('strong', { lang: 'hu', text: cim }));
      const urlap = el('form', { id, class: 'bai-urlap', novalidate: true, 'aria-label': T('notify.form', { cim }) },
        termek,
        el('div', { class: 'bai-mezo' }, el('label', { for: emailId, class: 'bai-cimke', text: T('notify.email') }), email, emailHiba),
        el('div', { class: 'bai-mezo' },
          el('label', { for: pipaId, class: 'bai-jelolo' }, pipa, pipaSzoveg),
          el('p', { id: segedId, class: 'bai-seged bai-behuzott', text: T('notify.consent_help') }),
          pipaHiba),
        el('p', { class: 'bai-seged', text: T('notify.after') }),
        kuldo);

      email.addEventListener('input', () => mezoHibaTorol(email, emailHiba, null));
      pipa.addEventListener('change', () => { if (pipa.checked) mezoHibaTorol(pipa, pipaHiba, segedId); });
      urlap.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (kuldo.getAttribute('aria-busy') === 'true') return;
        const ertek = email.value.trim();
        let elso = null;
        if (!EMAIL_MINTA.test(ertek)) { mezoHiba(email, emailHiba, T('form.err_email'), null); elso = elso || email; }
        else mezoHibaTorol(email, emailHiba, null);
        if (!pipa.checked) { mezoHiba(pipa, pipaHiba, T('notify.err_consent'), segedId); elso = elso || pipa; }
        else mezoHibaTorol(pipa, pipaHiba, segedId);
        if (elso) { elso.focus(); return; }

        kuldoGombFoglalt(kuldo, true, T('notify.button'));
        let r;
        try {
          await elokeszit();
          r = await munkamenetesKeres('/notify', {
            beszelgetes: A.conv || '', termek: k.id, email: ertek, hozzajarulas: true, nonce: akcio.nonce, nyelv: A.ny,
          });
        } catch (err) {
          r = null;
        }
        kuldoGombFoglalt(kuldo, false, T('notify.button'));
        if (r && r.status === 200 && r.adat.ok === true) {
          leiratkozas();
          urlap.remove();
          gomb.setAttribute('aria-expanded', 'false');
          logba(visszhang(T('notify.echo', { cim, email_maszk: emailMaszk(ertek) })));
          const tovabbi = [];
          tovabbi.push(el('p', { class: 'bai-kozepes', text: typeof r.adat.spam === 'string' ? r.adat.spam : T('notify.spam') }));
          const visszaNonce = typeof r.adat.visszavonas_nonce === 'string' ? r.adat.visszavonas_nonce : null;
          let vGomb = null;
          if (visszaNonce) {
            vGomb = el('button', { type: 'button', class: 'bai-linksor', text: T('notify.revoke') });
            tovabbi.push(vGomb);
          }
          const siker = sikerBuborek(typeof r.adat.szoveg === 'string' ? r.adat.szoveg : T('notify.sent'), tovabbi);
          logba(siker);
          if (vGomb) vGomb.addEventListener('click', () => visszavonas(k.id, visszaNonce, vGomb, siker));
          siker.focus();
          return;
        }
        if (r && r.status === 400 && r.adat.hiba === 'form.err_email') { mezoHiba(email, emailHiba, r.adat.szoveg || T('form.err_email'), null); email.focus(); return; }
        if (r && r.status === 400 && r.adat.hiba === 'notify.err_consent') { mezoHiba(pipa, pipaHiba, r.adat.szoveg || T('notify.err_consent'), segedId); pipa.focus(); return; }
        if (r && (r.status === 503 || r.status === 429) && r.adat.mod) { modValtas(r.adat.mod); return; }
        leiratkozas();
        urlap.remove();
        gomb.setAttribute('aria-expanded', 'false');
        hibaBuborek(r && typeof r.adat.szoveg === 'string' && r.adat.szoveg ? r.adat.szoveg : T('notify.fail'), null);
      });
      return { urlap, email };
    }

    let aktualis = epit();
    const csere = () => {
      const uj = epit();
      aktualis.urlap.replaceWith(uj.urlap);
      aktualis = uj;
      ui.ertesitesUrlap = uj.urlap;
      gomb.setAttribute('aria-controls', uj.urlap.id);
    };
    const leiratkozas = nyelvFigyelo(csere);
    ui.ertesitesUrlap = aktualis.urlap;
    tarto.after(aktualis.urlap);
    gomb.setAttribute('aria-expanded', 'true');
    gomb.setAttribute('aria-controls', aktualis.urlap.id);
    aktualis.email.focus();
  }

  async function visszavonas(termek, nonce, gomb, siker) {
    if (gomb.getAttribute('aria-busy') === 'true') return;
    gomb.setAttribute('aria-busy', 'true');
    let r = null;
    try {
      r = await munkamenetesKeres('/notify/visszavonas', { beszelgetes: A.conv || '', termek, nonce, nyelv: A.ny });
    } catch (e) {
      r = null;
    }
    gomb.remove();   // a nonce egyszer használható
    if (r && r.status === 200 && r.adat.ok === true) {
      logba(visszhang(typeof r.adat.szoveg === 'string' && r.adat.szoveg ? r.adat.szoveg : T('notify.revoked')));
      return;
    }
    const p = el('p', { class: 'bai-hibaszoveg' }, ikon('figyel', 14, 2.2),
      el('span', { text: r && typeof r.adat.szoveg === 'string' && r.adat.szoveg && r.status === 502 ? r.adat.szoveg : T('notify.revoke_fail') }));
    siker.append(p);
    hirdetes(T('notify.revoke_fail'));
  }

  // ------------------------------------------------------------------------------------------- átadás (M07/M08)
  function atadasUrlap(akcio, gomb) {
    const ui = A.ui;
    if (ui.atadasUrlap && ui.atadasUrlap.isConnected) { ui.atadasUrlap.querySelector('input').focus(); return; }
    const kerdes = A.utolsoVevo.slice(0, MAX_KERDES);

    function epit() {
      const id = uid('at');
      const emailId = uid('at-email');
      const emailHibaId = uid('at-email-hiba');
      const rendId = uid('at-rendeles');
      const rendSegedId = uid('at-rendeles-seged');
      const rendHibaId = uid('at-rendeles-hiba');
      const megjId = uid('at-megj');
      const email = el('input', { id: emailId, class: 'bai-input', type: 'email', autocomplete: 'email', inputmode: 'email', maxlength: '254' });
      const emailHiba = hibaP(emailHibaId);
      const rend = el('input', { id: rendId, class: 'bai-input', type: 'text', autocomplete: 'off', maxlength: '20', 'aria-describedby': rendSegedId });
      const rendHiba = hibaP(rendHibaId);
      const megj = el('textarea', { id: megjId, class: 'bai-input', rows: '2', maxlength: String(MAX_KERDES), placeholder: T('handoff.note_ph') });
      const adatv = el('p', { class: 'bai-seged' });
      adatv.append(szovegLinkekkel(T('handoff.privacy')));
      const kuldo = el('button', { type: 'submit', class: 'bai-urlap-gomb', 'aria-busy': 'false', text: T('handoff.button') });
      const reszek = [];
      if (kerdes) reszek.push(el('div', { class: 'bai-idezet' }, T('handoff.quote') + ' ', el('span', { text: '„' + kerdes + '”' })));
      const urlap = el('form', { id, class: 'bai-urlap', novalidate: true, 'aria-label': T('handoff.form') },
        ...reszek,
        el('div', { class: 'bai-mezo' }, el('label', { for: emailId, class: 'bai-cimke', text: T('handoff.email') }), email, emailHiba),
        el('div', { class: 'bai-mezo' },
          el('label', { for: rendId, class: 'bai-cimke' }, cimkeSzoveg(T('handoff.order'))), rend,
          el('p', { id: rendSegedId, class: 'bai-seged', text: T('handoff.order_note') }), rendHiba),
        el('div', { class: 'bai-mezo' }, el('label', { for: megjId, class: 'bai-cimke' }, cimkeSzoveg(T('handoff.note'))), megj),
        adatv,
        kuldo);

      email.addEventListener('input', () => mezoHibaTorol(email, emailHiba, null));
      rend.addEventListener('input', () => mezoHibaTorol(rend, rendHiba, rendSegedId));
      urlap.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (kuldo.getAttribute('aria-busy') === 'true') return;
        const ertek = email.value.trim();
        const rendszam = rend.value.trim();
        let elso = null;
        if (!EMAIL_MINTA.test(ertek)) { mezoHiba(email, emailHiba, T('form.err_email'), null); elso = email; }
        else mezoHibaTorol(email, emailHiba, null);
        if (rendszam && !RENDELESSZAM_MINTA.test(rendszam)) { mezoHiba(rend, rendHiba, T('handoff.order_err'), rendSegedId); elso = elso || rend; }
        else mezoHibaTorol(rend, rendHiba, rendSegedId);
        if (elso) { elso.focus(); return; }

        kuldoGombFoglalt(kuldo, true, T('handoff.button'));
        let r = null;
        try {
          await elokeszit();
          const torzs = {
            okkod: akcio.okkod, nonce: akcio.nonce, beszelgetes: A.conv || '', email: ertek, kerdes,
            megjegyzes: megj.value.slice(0, MAX_KERDES), nyelv: A.ny,
          };
          if (rendszam) torzs.rendelesszam = rendszam;
          if (A.cfg.termek && (A.belepesi === 'termekoldal' || A.belepesi === 'hasonlo')) torzs.termek = A.cfg.termek.id;
          r = await munkamenetesKeres('/handoff', torzs);
        } catch (err) {
          r = null;
        }
        kuldoGombFoglalt(kuldo, false, T('handoff.button'));
        if (r && r.status === 200 && r.adat.ok === true) {
          leiratkozas();
          urlap.remove();
          logba(visszhang(T('handoff.echo', { email_maszk: emailMaszk(ertek) })));
          const tovabbi = [];
          if (typeof r.adat.utana === 'string' && r.adat.utana) tovabbi.push(el('p', { text: r.adat.utana }));
          const siker = sikerBuborek(typeof r.adat.szoveg === 'string' ? r.adat.szoveg : '', tovabbi);
          logba(siker);
          const chipek = T('chips.start').split(' · ').map((s) => s.trim()).filter(Boolean).slice(0, 3);
          logba(chipCsoport(chipek, T('chips.after_label')));
          siker.focus();
          return;
        }
        if (r && r.status === 400 && r.adat.hiba === 'form.err_email') { mezoHiba(email, emailHiba, r.adat.szoveg || T('form.err_email'), null); email.focus(); return; }
        if (r && r.status === 400 && r.adat.hiba === 'handoff.order_err') { mezoHiba(rend, rendHiba, r.adat.szoveg || T('handoff.order_err'), rendSegedId); rend.focus(); return; }
        if (r && r.status === 503 && r.adat.mod) { modValtas(r.adat.mod); return; }
        leiratkozas();
        urlap.remove();
        hibaBuborek(r && typeof r.adat.szoveg === 'string' && r.adat.szoveg ? r.adat.szoveg : T('handoff.fail'), null);
      });
      return { urlap, email };
    }

    let aktualis = epit();
    const csere = () => {
      const uj = epit();
      aktualis.urlap.replaceWith(uj.urlap);
      aktualis = uj;
      ui.atadasUrlap = uj.urlap;
      if (gomb) gomb.setAttribute('aria-controls', uj.urlap.id);
    };
    const leiratkozas = nyelvFigyelo(csere);
    ui.atadasUrlap = aktualis.urlap;
    logba(aktualis.urlap);
    if (gomb && gomb.classList.contains('bai-gomb-teli')) {
      gomb.setAttribute('aria-expanded', 'true');
      gomb.setAttribute('aria-controls', aktualis.urlap.id);
    }
    aktualis.email.focus();
  }

  // ------------------------------------------------------------------------------------------- nem elérhető (M10, `ki`)
  function urlapNezet(mod) {
    const ui = A.ui;
    if (!ui) return;
    ui.csevego.hidden = true;
    ui.csevego.style.display = 'none';
    const t = ui.urlapTarto;
    t.hidden = false;
    t.replaceChildren();
    if (ui.urlapLeiratkozas) { ui.urlapLeiratkozas(); ui.urlapLeiratkozas = null; }

    const jelzes = el('div', { class: 'bai-nemelerheto', role: 'status' },
      ikon('figyel', 22, 2),
      el('div', { class: 'bai-nemelerheto-szoveg' },
        el('div', { class: 'bai-nemelerheto-cim', text: T('unavailable.title') }),
        mod === 'urlap' ? el('div', { class: 'bai-nemelerheto-torzs', text: T('unavailable.body') }) : null));
    t.append(jelzes);
    if (mod === 'urlap') t.append(urlapModUrlap());
    t.append(link(UTAK.kereses, T('unavailable.search'), 'bai-linksor bai-kozepre'));
  }

  function urlapModUrlap() {
    const emailId = uid('ne-email');
    const emailHibaId = uid('ne-email-hiba');
    const kerdesId = uid('ne-kerdes');
    const kerdesHibaId = uid('ne-kerdes-hiba');
    const szamlaloId = uid('ne-szamlalo');
    const email = el('input', { id: emailId, class: 'bai-input', type: 'email', autocomplete: 'email', inputmode: 'email', maxlength: '254' });
    const emailHiba = hibaP(emailHibaId);
    const kerdes = el('textarea', { id: kerdesId, class: 'bai-input bai-magas', rows: '3', maxlength: String(MAX_KERDES), placeholder: T('unavailable.question_ph'), 'aria-describedby': szamlaloId });
    const szamlalo = el('div', { id: szamlaloId, class: 'bai-szamlalo', text: T('unavailable.counter', { n: 0 }) });
    const kerdesHiba = hibaP(kerdesHibaId);
    const adatv = el('p', { class: 'bai-seged' });
    adatv.append(szovegLinkekkel(T('unavailable.privacy')));
    const kuldo = el('button', { type: 'submit', class: 'bai-urlap-gomb', 'aria-busy': 'false', text: T('handoff.button') });
    const urlap = el('form', { class: 'bai-urlap', novalidate: true, 'aria-label': T('unavailable.form') },
      el('div', { class: 'bai-mezo' }, el('label', { for: emailId, class: 'bai-cimke', text: T('handoff.email') }), email, emailHiba),
      el('div', { class: 'bai-mezo' }, el('label', { for: kerdesId, class: 'bai-cimke', text: T('unavailable.question') }), kerdes, szamlalo, kerdesHiba),
      adatv,
      kuldo);
    kerdes.addEventListener('input', () => {
      szamlalo.textContent = T('unavailable.counter', { n: kerdes.value.length });
      mezoHibaTorol(kerdes, kerdesHiba, szamlaloId);
    });
    email.addEventListener('input', () => mezoHibaTorol(email, emailHiba, null));
    urlap.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (kuldo.getAttribute('aria-busy') === 'true') return;
      const ertek = email.value.trim();
      const k = kerdes.value.trim();
      let elso = null;
      if (!EMAIL_MINTA.test(ertek)) { mezoHiba(email, emailHiba, T('form.err_email'), null); elso = email; }
      else mezoHibaTorol(email, emailHiba, null);
      if (!k) { mezoHiba(kerdes, kerdesHiba, T('form.err_question'), szamlaloId); elso = elso || kerdes; }
      else mezoHibaTorol(kerdes, kerdesHiba, szamlaloId);
      if (elso) { elso.focus(); return; }
      kuldoGombFoglalt(kuldo, true, T('handoff.button'));
      let r = null;
      try {
        const torzs = { email: ertek, kerdes: k.slice(0, MAX_KERDES), nyelv: A.ny };
        if (A.conv) torzs.beszelgetes = A.conv;
        r = await api('POST', '/handoff', torzs, { token: true });
      } catch (err) {
        r = null;
      }
      kuldoGombFoglalt(kuldo, false, T('handoff.button'));
      if (r && r.status === 200 && r.adat.ok === true) {
        const siker = sikerBuborek(typeof r.adat.szoveg === 'string' ? r.adat.szoveg : '', []);
        urlap.replaceWith(siker);
        siker.focus();
        return;
      }
      if (r && r.status === 400 && r.adat.hiba === 'form.err_email') { mezoHiba(email, emailHiba, r.adat.szoveg || T('form.err_email'), null); email.focus(); return; }
      if (r && r.status === 400 && r.adat.hiba === 'form.err_question') { mezoHiba(kerdes, kerdesHiba, r.adat.szoveg || T('form.err_question'), szamlaloId); kerdes.focus(); return; }
      if (r && r.status === 503 && r.adat.mod === 'ki') { modValtas('ki'); return; }
      const hiba = el('p', { class: 'bai-hibaszoveg' }, ikon('figyel', 14, 2.2),
        el('span', { text: r && typeof r.adat.szoveg === 'string' && r.adat.szoveg ? r.adat.szoveg : T('handoff.fail') }));
      urlap.insertBefore(hiba, kuldo);
      kuldo.focus();
    });
    return urlap;
  }

  // ------------------------------------------------------------------------------------------- oldal-konfiguráció
  function oldalKonfig() {
    const s = document.getElementById('booksy-ai-adat');
    if (!s) return null;
    let c;
    try { c = JSON.parse(s.textContent || '{}'); } catch (e) { return null; }
    if (!c || typeof c !== 'object') return null;
    const b = c.belepok && typeof c.belepok === 'object' ? c.belepok : {};
    const t = c.termek && typeof c.termek === 'object' ? c.termek : null;
    const k = c.kereses && typeof c.kereses === 'object' ? c.kereses : {};
    return {
      api: typeof c.api === 'string' ? c.api : '/ai/v1',
      mod: c.mod === 'ki' ? 'ki' : null,
      oldal: c.oldal === 'termek' || c.oldal === 'kereses' ? c.oldal : 'egyeb',
      belepok: { termekoldal: b.termekoldal === true, kereses: b.kereses === true, lebego: b.lebego === true },
      termek: t && (typeof t.id === 'string' || typeof t.id === 'number') && typeof t.cim === 'string'
        ? {
          id: String(t.id).slice(0, 20), cim: t.cim.slice(0, 200), tipus: String(t.tipus || ''), available: t.available !== false,
          handle: typeof t.handle === 'string' && /^[a-z0-9][a-z0-9\-]{0,199}$/.test(t.handle) ? t.handle : null,
        }
        : null,
      talalat: Number.isInteger(k.talalat) && k.talalat >= 0 ? k.talalat : null,
      feltetelek: c.feltetelek_el === true,
      nyelv: c.nyelv === 'ro' ? 'ro' : c.nyelv === 'hu' ? 'hu' : null,
    };
  }

  function kezdoNyelv(c) {
    if (c.nyelv) return c.nyelv;
    const l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return l.slice(0, 2) === 'ro' ? 'ro' : 'hu';
  }

  function indit() {
    if (A.inditva) return;
    A.inditva = true;
    const c = oldalKonfig();
    if (!c) return;
    A.cfg = c;
    A.api = apiAlap(c.api);
    if (!A.api) return;
    A.ny = kezdoNyelv(c);
    tarolo.lejartTorles(Date.now());   // csak olvasás + lejárt törlése; írás csak az első érintés után
    if (c.mod === 'ki') return;        // téma-szintű vészkapcsoló: semmi nem renderel, kérés nincs
    belepokRenderelese();
    g.addEventListener('popstate', () => { if (A.nyitva) zar({ popstate: true }); });
    if (g.matchMedia) {
      const mq = g.matchMedia(MOBIL_MQ);
      const valt = () => elrendezes();
      if (mq.addEventListener) mq.addEventListener('change', valt); else if (mq.addListener) mq.addListener(valt);
    }
    g.BooksyAI = Object.freeze({
      megnyit: () => megnyit({ forras: 'kulso', gomb: document.activeElement instanceof HTMLElement ? document.activeElement : null }),
      bezar: () => zar(),
    });
  }

  // Egységteszt-hozzáférés (csak Node-ban, a tesztfuttató állítja be; böngészőben a jelző nincs).
  if (g.__BAI_TESZT__ === true && typeof document === 'undefined') {
    g.__BAI_BELSO__ = {
      A, T, darabol, gombAkcio, tarolo, munkamenetOlvas, biztonsagosUrl, apiAlap, emailMaszk, sseBlokk, altchaMegold,
      jelvenyFajta, KULCS_SESSION, KULCS_CONV, ELETTARTAM_MS,
    };
  }

  if (typeof document !== 'undefined' && document.documentElement) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indit, { once: true });
    else indit();
  }
})();
